/* eslint-disable */
import React, { useState, useContext, useEffect } from 'react';
import { IconButton, InputBase, TextField, Typography, Button, Checkbox, FormControlLabel, TextareaAutosize } from '@mui/material';
import Grid from '@mui/material/Grid';
import { Link, useNavigate } from 'react-router-dom';

import { Box } from '@mui/system';
import PageLayout from '../../../Components/PageLayout';
import DatePicker, { DateObject } from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import persian_en from "react-date-object/locales/persian_en";
import { ReactComponent as CalendarIcon } from "../../../Assets/svg/CalendarIcon.svg";
// import { ReactComponent as CopyIcon } from "../../../Assets/svg/CopyIcon.svg";
import { ReactComponent as ContactIcon } from "../../../Assets/svg/ContactIcon.svg";
import { ReactComponent as CityIcon } from "../../../Assets/svg/CityIcon.svg";
import { ReactComponent as SettingIcon } from "../../../Assets/svg/SettingIcon.svg";
import { ReactComponent as PlusIcon } from "../../../Assets/svg/PlusIcon.svg";
import { ReactComponent as CloseIcon } from "../../../Assets/svg/CloseIcon.svg";
import { ReactComponent as SreachIcon } from "../../../Assets/svg/SreachIcon.svg";
import { ReactComponent as ArrowRightIcon } from "../../../Assets/svg/ArrowRightIcon.svg";
// import { ReactComponent as ArrowRightIconGreen } from "../../../Assets/svg/greenArrow.svg";
import { ReactComponent as StarIcon } from "../../../Assets/svg/StarIcon.svg";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Slide from '@mui/material/Slide';
import { DemandContext } from '../../../context/demand-context';
import data from '../../../api/melkData.json';
// import Alert from '@mui/material/Alert';
// import Collapse from '@mui/material/Collapse';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import http from '../../../api/axiosInstance';
import { NumericFormat } from 'react-number-format';
import {
    useParams
} from "react-router-dom";
import { TileLayer, useMapEvents, Marker, Popup, MapContainer } from 'react-leaflet'
import { useSnackbar } from 'notistack';
import { useUserStore } from '../../../store/user';
import { ReactComponent as DownloadIcon } from "../../../Assets/svg/DownloadIcon.svg";
import { ReactComponent as PersonList } from "../../../Assets/svg/PersonList.svg";
import {
    Picker,
    format,
    newDate,
    DatePickerConfig,
} from '@persian-tools/persian-mobile-datepicker';
import moment from 'jalali-moment';
import { config } from '../../../Components/persian-mobile-datepicker-config'
import { scrollingDiv } from '../../../Components/ScrollRightToLeftDrag'
import Cookies from 'js-cookie'
import { priceItems, meterItems } from "../../../api/ListData"

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ py: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        className: 'tab-btn',
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const NumericFormatCustom = React.forwardRef(function NumericFormatCustom(
    props,
    ref,
) {
    const { onChange, ...other } = props;

    return (
        <NumericFormat
            {...other}
            getInputRef={ref}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            thousandSeparator
            valueIsNumericString
            prefix=""
        />
    );
});

NumericFormatCustom.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};


function LocationMarker(props) {
    const [position, setPosition] = useState(null)
    const map = useMapEvents({
        click(e) {
            map.locate()
            setPosition(e.latlng)
            props.LatLongHandle(e.latlng)
        },
    })

    return position === null ? "" : (
        <Marker position={position}>
            <Popup>You are here</Popup>
        </Marker>
    )
}




function EditDemand(props) {

    const [state, dispatch] = useContext(DemandContext);

    // let { type } = useParams()

    let { id } = useParams()


    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();


    const [imgUploadsCount, setImgUploadsCount] = useState([{}])
    const [tabValue, setTabValue] = React.useState(0);
    const [openZoneModal, setOpenZoneModal] = React.useState(false);
    const [openFloorModal, setOpenFloorModal] = React.useState(false);
    const [openEmkanatModal, setOpenEmkanatModal] = React.useState(false);
    const [openProperty, setOpenProperty] = React.useState(false);
    // const [openCodeMelk, setOpenCodeMelk] = React.useState(false);
    const [openSanadModal, setOpenSanadModal] = React.useState(false);
    const [openJahatModal, setoOpenJahatModal] = React.useState(false);
    const [openNamaModal, setoOpenNamaModal] = React.useState(false);
    const [openKafpooshModal, setOpenKafpooshModal] = React.useState(false);
    const [openGarmayeshModal, setOpenGarmayeshModal] = React.useState(false);
    const [openKitchenModal, setOpenKitchenModal] = React.useState(false);
    const [openSarmayeshModal, setOpenSarmayeshModal] = React.useState(false);
    // const [openMapModal, setOpenMapModal] = React.useState(false);
    const [showLoan, setShowLoan] = React.useState(false);
    const [floorNumModal, setFloorNumModal] = React.useState(false);
    const [nowDate, setNowDate] = React.useState("");
    const [yearDates, setYearDates] = React.useState([]);
    const [yearCreated, setYearCreated] = React.useState(false);
    const [yearSlected, setYearSlected] = React.useState("");

    const [tmpRentPriceModal, setTmpRentPriceModal] = React.useState(false);
    const [rentPredereModal, setRentPredereModal] = React.useState(false);
    const [tmpMortgagePriceModal, setTmpMortgagePriceModal] = React.useState(false);
    const [selectMeterModal, setSelectMeterModal] = React.useState(false);
    const [selectSpaceModal, setSelectSpaceModal] = React.useState(false);
    const [propInfo, setPropInfo] = useState({})

    const [minValue, setMinValue] = useState(0)
    const [maxValue, setMaxValue] = useState(0)


    const [meterPrice, setMeterPrice] = React.useState(0);
    // const [openAlert, setOpenAlert] = React.useState(false);
    const [searchPropCode, setSearchPropCode] = React.useState("");
    const [showSalePrice, setShowSalePrice] = React.useState("");
    const [showMortgagePrice, setShowMortgagePrice] = React.useState("");
    const [openBackdrop, setOpenBackdrop] = React.useState(false);
    const [areasItems, setAreasItems] = React.useState([]);
    const [validation, setValidation] = React.useState({});
    const [floorItem, setFloorItem] = React.useState({
        "FloorNo": "",
        "Infrastructure": "",
        "RoomsCount": "1",
        "Water": "",
        "Electricity": "",
        "Gas": "",
        "Phone": "",
        "Description": ""
    },);
    const [tmpSalePriceModal, setTmpSalePriceModal] = React.useState(false);
    const [showPriceItem, setShowPriceItem] = React.useState(0);
    const [showMeterItem, setShowMeterItem] = React.useState(0);

    const positionMap = [36.32386694335946, 59.579383705135136]

    const floorTitle = { "-2": '-2', "-1": '-1', "0": 'همکف', "1": 'اول', "2": 'دوم', "3": 'سوم', "4": 'چهارم', "5": 'پنجم', "6": 'ششم', "7": 'هفتم', "8": 'هشتم', "9": 'نهم', "10": "دهم", "11": "یازدهم" }

    const accessToken = useUserStore((state) => state.accessToken)
    const userInfo = useUserStore((state) => state.userInfo)
    const propFacilities = useUserStore((state) => state.propFacilities)
    const locationId = useUserStore((state) => state.locationId)

    const [openTypeZone, setOpenTypeZone] = React.useState(false);
    const [typeZone, setTypeZone] = React.useState(1);
    const rentPrefer = ["مجرد", "سالمند", "متاهل", "جوان"]

    const [showPicker, setShowPicker] = React.useState(false);
    const [showExpireDatePicker, setShowExpireDatePicker] = React.useState(false);


    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    };
    const handleToggleBackdrop = () => {
        setOpenBackdrop(!openBackdrop);
    };

    const handleChangeFloor = (event, itemName) => {
        setFloorItem({ ...floorItem, [itemName]: event.target.value })
        console.log("floorItem", floorItem)
    };

    const submitFloorsHandle = () => {
        let flag = false
        for (const key in state.floors) {
            if (state.floors[key].FloorNo == floorItem.FloorNo) {
                flag = true
            }
        }

        if (!flag) {
            dispatch({
                type: "UPDATE_STATE",
                payload: { name: "floors", value: floorItem, append: true }
            });
            const variant = 'success'
            enqueueSnackbar('طبقه شما با موفقیت ثبت شد.', { variant });
            setFloorItem({
                "FloorNo": "",
                "Infrastructure": "",
                "RoomsCount": "1",
                "Water": "",
                "Electricity": "",
                "Gas": "",
                "Phone": "",
                "Description": ""
            })
        }
    };

    const clearFloorsHandle = () => {
        setFloorItem({
            "FloorNo": "",
            "Infrastructure": "",
            "RoomsCount": "1",
            "Water": "",
            "Electricity": "",
            "Gas": "",
            "Phone": "",
            "Description": ""
        })
    }

    const setFloor = (floor) => {
        for (const key in state.floors) {
            if (state.floors[key].FloorNo == floor) {
                setFloorItem(state.floors[key])
            }
        }
    };

    const removeFloor = (floor) => {

        let tmp = state.floors

        tmp = tmp.filter(item => item.FloorNo != floor)

        dispatch({
            type: "CLEAR_ITEM",
            payload: { name: "floors" }
        });

        for (const key in tmp) {
            dispatch({
                type: "UPDATE_STATE",
                payload: { name: "floors", value: tmp[key], append: true }
            });
        }
    };

    const handleCloseYearCreatedModal = () => {
        setYearCreated(false);
    };

    const handleOpenYearCreatedModal = () => {
        setYearCreated(true);
    };

    const handleClickTmpSalePriceModal = () => {
        setTmpSalePriceModal(true);
        setMinValue(state.MinSalePrice)
        setMaxValue(state.MaxSalePrice)
        setShowMeterItem(1)
    };

    const handleSaleTmpSalePriceModalClose = () => {

        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "MinSalePrice", value: minValue }
        });
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "MaxSalePrice", value: maxValue }
        });
        setTmpSalePriceModal(false);
    };

    const handleClickRentPrefereModal = () => {
        setRentPredereModal(true);
    };

    const handleSaleRentPreferModalClose = () => {
        setRentPredereModal(false);
    };

    const handleClickTmpRentPriceModal = () => {
        setTmpRentPriceModal(true);
        setMinValue(state.MinRentPrice)
        setMaxValue(state.MaxRentPrice)
        setShowMeterItem(1)
    };

    const handleSaleTmpRentPriceModalClose = () => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "MinRentPrice", value: minValue }
        });
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "MaxRentPrice", value: maxValue }
        });
        setTmpRentPriceModal(false);
    };

    const handleClickTmpMortgagePriceModal = () => {
        setTmpMortgagePriceModal(true);
        setMinValue(state.MinMortgagePrice)
        setMaxValue(state.MaxMortgagePrice)
        setShowMeterItem(1)
    };

    const handleSaleTmpMortgagePriceModalClose = () => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "MinMortgagePrice", value: minValue }
        });
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "MaxMortgagePrice", value: maxValue }
        });
        setTmpMortgagePriceModal(false);
    };

    const handleClickOpenZoneModal = () => {
        setOpenZoneModal(true);
        setTimeout(function () {
            if (document && typeof document.getElementById("areas-container") !== 'undefined' && document.getElementById("areas-container") !== null && areasItems.length > 0) {
                document.getElementById("areas-container").addEventListener('scroll', areaOnScroll)
                return () => document.getElementById("areas-container").removeEventListener('scroll', areaOnScroll)
            }
        }, 500)
    };

    const handleClose = () => {
        setOpenZoneModal(false);
    };

    const handleClickOpenFloorModal = () => {
        setOpenFloorModal(true);
    };

    const handleFloorClose = () => {
        setOpenFloorModal(false);
    };

    const handleClickOpenEmkanatModal = () => {
        setOpenEmkanatModal(true);
    };

    const handleEmkanatClose = () => {
        setOpenEmkanatModal(false);
    };

    const handleClickOpenPropertyModal = () => {
        setOpenProperty(true);
    };

    const handleProperyClose = () => {
        setOpenProperty(false);
    };
    // const handleClickOpenOpenCodeMelk = () => {
    //     setOpenCodeMelk(true);
    // };
    // const handleCodeMelkClose = () => {
    //     setOpenCodeMelk(false);
    // };

    const handleClickOpenSanadModal = () => {
        setOpenSanadModal(true);
    };
    const handleCloseSanadModal = () => {
        setOpenSanadModal(false);
    };

    const handleClickOpenJahatModal = () => {
        setoOpenJahatModal(true);
    };
    const handleCloseJahatModal = () => {
        setoOpenJahatModal(false);
    };

    const handleClickOpenNamaModal = () => {
        setoOpenNamaModal(true);
    };
    const handleCloseNamaModal = () => {
        setoOpenNamaModal(false);
    };

    const handleClickOpenKafpooshModal = () => {
        setOpenKafpooshModal(true);
    };
    const handleCloseKafpooshModal = () => {
        setOpenKafpooshModal(false);
    };

    const handleClickOpenGarmayeshModal = () => {
        setOpenGarmayeshModal(true);
    };
    const handleCloseGarmayeshModal = () => {
        setOpenGarmayeshModal(false);
    };

    const handleClickOpenKitchenhModal = () => {
        setOpenKitchenModal(true);
    };
    const handleCloseKitchenModal = () => {
        setOpenKitchenModal(false);
    };

    const handleClickOpenSarmayeshModal = () => {
        setOpenSarmayeshModal(true);
    };
    const handleCloseSarmayeshModal = () => {
        setOpenSarmayeshModal(false);
    };

    // const handleClickOpenMapModal = () => {
    //     setOpenMapModal(true);
    // };
    // const handleCloseMapModal = () => {
    //     setOpenMapModal(false);
    // };

    const handleOpenFloorNumModal = () => {
        setFloorNumModal(true);
    };
    const handleCloseFloorNumModal = () => {
        setFloorNumModal(false);
    };


    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const handleClickSelectMeterModal = () => {
        setSelectMeterModal(true);
        setMinValue(state.MinInfrastructure)
        setMaxValue(state.MaxInfrastructure)
        setShowPriceItem(1)
    };

    const handleSelectMeterModalClose = () => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "MinInfrastructure", value: minValue }
        });
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "MaxInfrastructure", value: maxValue }
        });
        setSelectMeterModal(false);
    };

    const handleClickSelectSpaceModal = () => {
        setSelectSpaceModal(true);
        setMinValue(state.MinSpace)
        setMaxValue(state.MaxSpace)
        setShowPriceItem(1)
    };

    const handleSelectSpaceModalClose = () => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "MinSpace", value: minValue }
        });
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "MaxSpace", value: maxValue }
        });
        setSelectSpaceModal(false);
    };


    const RegisterDateHandle = (selectedDate) => {
        const date = format(selectedDate.date, "yyyy/MM/dd");
        const events = selectedDate.events;
        console.log(selectedDate.date, events)
        // console.log(moment.unix(+selectedDate.date).format("jYYYY/jMM/jDD"));
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "RegisterDate", value: +selectedDate.date }
        });
    }

    const ExpireDateHandle = (selectedDate) => {
        const date = format(selectedDate.date, "yyyy/MM/dd");
        const events = selectedDate.events;
        console.log("state.ExpireDate", state.ExpireDate)
        console.log(+selectedDate.date)

        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "ExpireDate", value: +selectedDate.date }
        });
    }

    const ExpireDateEmpty = () => {

        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "ExpireDate", value: "" }
        });
    }

    const RegisterDateEmpty = () => {

        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "RegisterDate", value: "" }
        });
    }

    const PhoneHandle = (e) => {
        // console.log(e.target.value)
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Phone", value: e.target.value }
        });
    }

    const MobileHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Mobile", value: e.target.value }
        });
    }

    const PropertyTypeHandle = (e) => {

        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "PropertyTypes", value: e.target.value }
        });
    }

    const disPropertyTypeHandle = (e) => {

        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "PropertyType", value: "" }
        });
    }

    const AddressHandle = (e) => {

        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Address", value: e.target.value }
        });
    }


    const InfrastructureHandle = (e) => {

        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Infrastructure", value: e.target.value }
        });
    }

    const SpaceHandle = (e) => {

        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Space", value: e.target.value }
        });
    }

    const RoomsCountHandle = (e) => {

        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "MinRoomsCount", value: e.target.value }
        });
        console.log("MinRoomsCount", state.MinRoomsCount)
    }

    const FloorsHandle = (e) => {

        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "floors", value: e.target.value }
        });
    }

    const StoreyCountHandle = (e) => {

        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "StoreyCount", value: e.target.value }
        });
    }

    const UnitsCountHandle = (e) => {

        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "UnitsCount", value: e.target.value }
        });
    }

    const LoanPriceHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "LoanPrice", value: e.target.value }
        });
    }

    const AccountTypeKeyHandel = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "UsageTypes", value: e.target.value }
        });
    }

    const FacilitiesHandel = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Facilities", value: e.target.value }
        });
    }

    const WaterHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Water", value: e.target.value }
        });
    }

    const disWaterHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Water", value: "" }
        });
    }

    const ElectricityHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Electricity", value: e.target.value }
        });
    }

    const disElectricityHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Electricity", value: "" }
        });
    }

    const GasHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Gas", value: e.target.value }
        });
    }

    const disGasHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Gas", value: "" }
        });
    }


    const PropertyAgeYearHandle = (e) => {
        const finalDate = nowDate - e.target.value
        console.log(finalDate)
        setYearSlected(e.target.value)

        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "PropertyAge", value: finalDate }
        });
    }

    // const disPropertyAgeYearHandle = (e) => {
    //     setYearSlected("")
    //     dispatch({
    //         type: "UPDATE_STATE",
    //         payload: { name: "PropertyAge", value: "" }
    //     });
    // }

    const EstateStatusHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "EstateStatus", value: e.target.value }
        });
    }

    const AggregationHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Aggregation", value: e.target.value }
        });
    }

    const CertificateTypeHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "CertificateType", value: e.target.value }
        });
    }

    const DirectionHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Direction", value: e.target.value }
        });
    }

    const FrontageHandle = (e) => {
        console.log(e.target.value)
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Frontage", value: e.target.value }
        });
    }

    const FloorHandle = (e) => {

        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Floor", value: e.target.value }
        });
    }




    const KitchenServiceHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "KitchenService", value: e.target.value }
        });
    }

    const PublicDescriptionHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "PublicDescription", value: e.target.value }
        });
    }

    const DescriptionHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Description", value: e.target.value }
        });
    }

    const featureHandle = (e) => {
        console.log(e.target.checked)
        let value = "0"
        if (e.target.checked)
            value = "1"
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: e.target.value, value: value }
        });
    }

    const LatLongHandle = (latlng) => {
        console.log(latlng)
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Latitude", value: latlng.lat }
        });
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Longitude", value: latlng.lng }
        });
    }

    const handleChangeBaseOnPrice = (event) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "PriceCalcMode", value: event.target.value }
        });

    };

    const CurrentResidentPhoneNumberHandle = (event) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "CurrentResidentPhoneNumber", value: event.target.value }
        });
    };

    const meterPriceHandle = (e) => {
        if (state.Space != "") {
            if (state.PriceCalcMode == "Space") {
                if (e.target.value != "") {
                    console.log("meterPriceHandle", parseInt(state.Space) * parseInt(e.target.value))
                    dispatch({
                        type: "UPDATE_STATE",
                        payload: { name: "SalePrice", value: (parseInt(state.Space) * parseInt(e.target.value)).toString() }
                    });
                }
                else {
                    dispatch({
                        type: "UPDATE_STATE",
                        payload: { name: "SalePrice", value: "" }
                    });
                }
            }
        }
        if (state.Infrastructure != "") {
            if (state.PriceCalcMode == "Infrastructure") {
                if (e.target.value != "") {
                    dispatch({
                        type: "UPDATE_STATE",
                        payload: { name: "SalePrice", value: (parseInt(state.Infrastructure) * parseInt(e.target.value)).toString() }
                    });
                }
                else {
                    dispatch({
                        type: "UPDATE_STATE",
                        payload: { name: "SalePrice", value: "" }
                    });

                }
            }
        }
        setMeterPrice(e.target.value)
    }

    const SalePriceHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "SalePrice", value: e.target.value }
        });
        console.log(e.target.value)
        if (e.target.value == "") {
            setMeterPrice("")
        }
        else {
            if (state.Space != "") {
                if (state.PriceCalcMode == "Space") {
                    console.log("meterPriceHandle", parseInt(e.target.value) / parseInt(state.Space))
                    setMeterPrice(parseInt(e.target.value) / (parseInt(state.Space)).toString())
                }
            }
        }
        if (state.Infrastructure != "") {
            if (state.PriceCalcMode == "Infrastructure") {
                if (e.target.value != "") {
                    setMeterPrice(parseInt(e.target.value) / (parseInt(state.Infrastructure)).toString())

                }
                else {
                    setMeterPrice("")
                }
            }
        }
    }

    const RowHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Row", value: e.target.value }
        });
    }

    const FullNameHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "FullName", value: e.target.value }
        });
    }

    const PropertyAreaHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Areas", value: e.target.value }
        });
    }

    const MortgagePrice1Handle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "MortgagePrice1", value: e.target.value }
        });
        setShowMortgagePrice(wordifyfa(state.MortgagePrice1))
    }

    const RentPrice1Handle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "RentPrice1", value: e.target.value }
        });
    }

    const handleSetMinMaxSalePrice = (key, value) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: key, value: value }
        });

        if(key.includes("Min")){
            let minKey = key;
            let maxKey = key.replace("Min", "Max");
            if(state[maxKey] != 0 && parseInt(state[maxKey]) < parseInt(value)){
                setMinValue(state[maxKey]);
                setMaxValue(value);
            }
            else{
                setMinValue(value);
            }
        }
        else if(key.includes("Max")){
            let maxKey = key;
            let minKey = key.replace("Max", "Min");

            if(value != 0 && parseInt(value) < parseInt(state[minKey])){
                setMinValue(value);
                setMaxValue(state[minKey]);
            }
            else{
                setMaxValue(value);
            }
        }
    }

    const handleSetMinMaxMeter = (key, value) => {

        dispatch({
            type: "UPDATE_STATE",
            payload: { name: key, value: value }
        });

        if(key.includes("Min")){
            let minKey = key;
            let maxKey = key.replace("Min", "Max");
            if(state[maxKey] != 0 && state[maxKey] < value){
                setMinValue(state[maxKey]);
                setMaxValue(value);
            }
            else{
                setMinValue(value);
            }
        }
        else if(key.includes("Max")){
            let maxKey = key;
            let minKey = key.replace("Max", "Min");

            if(value != 0 && value < state[minKey]){
                setMinValue(value);
                setMaxValue(state[minKey]);
            }
            else{
                setMaxValue(value);
            }
        }
    }

    const RentPreferHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "RentPrefer", value: e.target.value }
        });
    }

    const handleChangeRadio = (key, e) => {
        console.log("e.target.checked", e.target.checked)
        if (e.target.checked) {
            dispatch({
                type: "UPDATE_STATE",
                payload: { name: key, value: "1" }
            });
        } else {
            dispatch({
                type: "UPDATE_STATE",
                payload: { name: key, value: "" }
            });
        }

    }

    //Areas Pagination

    const [areaOfsset, setAreaOfsset] = React.useState(0);
    const [hasMoreOffset, setHasMoreOffset] = React.useState(true);
    const [areasLoading, setAreasLoading] = React.useState(true);
    const [areaInPlusing, setAreaInPlusing] = React.useState(true);

    const areaOnScroll = () => {
        if (document.getElementById("areas-container")) {

            const scrollTop = document.getElementById("areas-container").scrollTop
            const scrollHeight = document.getElementById("areas-container").scrollHeight
            const clientHeight = document.getElementById("areas-container").clientHeight
            if (scrollTop + clientHeight >= scrollHeight && areaInPlusing) {
                setAreaInPlusing(false)
                setAreaOfsset(areaOfsset => areaOfsset + 40);

                // setSearchData({"name":"Offset","value":ofsset})
                console.log("areaOfsset", areaOfsset)
            }
        }
    }

    useEffect(() => {
        setTimeout(function () {
            if (document && typeof document.getElementById("areas-container") !== 'undefined' && document.getElementById("areas-container") !== null && areasItems.length > 0) {
                document.getElementById("areas-container").addEventListener('scroll', areaOnScroll)
                return () => document.getElementById("areas-container").removeEventListener('scroll', areaOnScroll)
            }
        }, 500)
    }, [areasItems])

    useEffect(() => {
        console.log("offset use")

        if (hasMoreOffset && areasItems.length) {
            if (typeZone == "1")
                getAreas(false, "", "/areas/list")
            if (typeZone == "2")
                getAreas(false, "", "/webapp/divar_areas/list")
        }
    }, [areaOfsset])



    const getAreas = (resetState = false, name = "", url = "/areas/list") => {
        if (resetState) {
            setAreasItems([])
            setAreaOfsset(0);
            setHasMoreOffset(true)
        }

        setAreasLoading(true)


        const data = {
            "LocationId": Cookies.get('locationId'),

            "AgencyId": JSON.parse(Cookies.get('agency')).Id,
            "Offset": areaOfsset,
            "Limit": 40
        }

        console.log("data", data)

        if (name != "") data["Name"] = name

        try {
            http({
                // url of the api endpoint (can be changed)
                url: url,
                method: "POST",
                data: data,
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {
                const tempAreas = [...areasItems]
                if (res.data.result.items.length > 0) {
                    if (!resetState) {
                        res.data.result.items.map((item, index) => {
                            tempAreas.push(item)
                        })
                        setAreasItems(tempAreas)
                        console.log("resetState not")
                    }
                    else
                        setAreasItems(res.data.result.items)

                    console.log("areasItems", areasItems)


                } else {
                    console.log("End")
                    setHasMoreOffset(false)
                    if (resetState) setAreasItems([])

                }
                setTimeout(function () { setAreaInPlusing(true) }, 1000)
                setAreasLoading(false)


            });
        } catch (e) {
            console.error(e);
            setAreasLoading(false)
        }
    }


    useEffect(() => {

        console.log("id", id)
        console.log("userInfo", userInfo)


        handleToggleBackdrop()
        if (locationId && locationId != "") {
            try {
                http({
                    // url of the api endpoint (can be changed)
                    url: "applicants/get/list/by/filter",
                    method: "POST",
                    data: {
                        "Id": id,
                        "AgencyInfo": true,
                        "LandLordInfo": true

                    },
                    headers: {
                        "Authorization": `Bearer ${Cookies.get('token')}`
                    }
                }).then((res) => {
                    console.log("propres", res.data.result.Applicants);
                    if (res.data.result.Applicants.length) {
                        let propertyTmp = { ...res.data.result.Applicants[0] }
                        for (const key in propertyTmp) {
                            if (key == "RegisterDate" || key == "ExpireDate") {


                                if (res.data.result.Applicants[0][key] && res.data.result.Applicants[0][key] != "")
                                    propertyTmp[key] = res.data.result.Applicants[0][key] * 1000

                            }
                        }
                        setPropInfo(propertyTmp)
                        dispatch({
                            type: "SET_ALL_ITEMS",
                            payload: { newState: propertyTmp }
                        });

                    } else {
                        const variant = 'error'
                        enqueueSnackbar('موردی یافت نشد!', { variant });
                        console.log("res");
                    }

                    handleCloseBackdrop()
                });

            } catch (e) {
                console.error(e);
                handleCloseBackdrop()
            }
        } else {
            setPropInfo({})
        }

    }, [userInfo])

    ///////////////////////

    const areasSearchHandle = async (e) => {

        handleToggleBackdrop()
        if (e.target.value != "") {
            if (typeZone == "1")
                getAreas(true, e.target.value, "/areas/list")
            if (typeZone == "2")
                getAreas(true, e.target.value, "/webapp/divar_areas/list")
        } else {
            if (typeZone == "1")
                getAreas(true, "", "/areas/list")
            if (typeZone == "2")
                getAreas(true, "", "/webapp/divar_areas/list")
        }
    }

    useEffect(() => {
        console.log("typeZone", typeZone)
        if (typeZone == "1")
            getAreas(true, "", "/areas/list")
        if (typeZone == "2")
            getAreas(true, "", "/webapp/divar_areas/list")


    }, [typeZone])

    const propCodeHandle = async () => {
        handleToggleBackdrop()
        try {
            await http({
                // url of the api endpoint (can be changed)
                url: "properties/get/list/by/filter",
                method: "POST",
                data: {
                    "LocationId": locationId,
                    "AgencyId": userInfo.Id,
                    "Row": searchPropCode
                }
            }).then((res) => {

                console.log(res);
                if (res.data.result.Properties.length) {
                    for (const key in state) {
                        if (key != 'Row') {
                            state[key] = res.data.result.Properties[0][key]
                        }
                    } handleCodeMelkClose()
                } else {
                    const variant = 'error'
                    enqueueSnackbar('موردی یافت نشد!', { variant });
                    console.log("res");
                }
                handleCloseBackdrop()


            });
        } catch (e) {
            console.error(e);
            handleCloseBackdrop()
        }

        // console.log("type", type)

    }

    const handleEditDemand = async () => {
        console.log(state)
        setValidation({})
        handleToggleBackdrop()

        const tmpState = { ...state }

        tmpState["PropertyId"] = id

        if (tmpState.RegisterDate != "")
            tmpState.RegisterDate = tmpState.RegisterDate / 1000
        if (tmpState.ExpireDate != "")
            tmpState.PeriodInDays = tmpState.ExpireDate / 1000

        try {
            await http({
                // url of the api endpoint (can be changed)
                url: `/applicants/${id}/update`,
                method: "POST",
                data: tmpState
            }).then((res) => {

                console.log(res.data.result)
                if (res.data.result != false) {
                    const variant = 'success'
                    enqueueSnackbar("تقاضا شما با موفقیت ویرایش شد.", { variant });
                    navigate("/applicant");
                }



                handleCloseBackdrop()


            });
        } catch (e) {
            console.error(e.response);
            if (e.response.data.result == false) {
                console.log("error")
                const variant = 'error'
                enqueueSnackbar(e.response.data.message, { variant });
                setValidation(e.response.data.validation)
            }
            handleCloseBackdrop()
        }
    }

    useEffect(() => {
        const date = new Date()
        const fullDate = `${date.getDay()}/${date.getMonth()}/${date.getFullYear()}`
        const format = "YYYY"
        let object = { fullDate, format }
        const now = new DateObject(object).convert(persian, persian_en).format()
        setNowDate(now)
        for (let i = parseInt(now); i >= parseInt(now) - 50; i--) {

            const tmp = yearDates
            tmp.push(i)
            setYearDates(tmp)
        }

        getAreas()

        scrollingDiv()
        document.getElementById("floorNo-container").scroll(650, 0);


        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "RegisterDate", value: +(new Date) }
        });

        // if (type == "sale") {
        //     console.log("sale")
        //     dispatch({
        //         type: "UPDATE_STATE",
        //         payload: { name: "RequestSale", value: "1" }
        //     });
        //     dispatch({
        //         type: "UPDATE_STATE",
        //         payload: { name: "RequestRent", value: "" }
        //     });
        //     dispatch({
        //         type: "UPDATE_STATE",
        //         payload: { name: "RequestPreSale", value: "" }
        //     });
        //     dispatch({
        //         type: "UPDATE_STATE",
        //         payload: { name: "RequestAssociate", value: "" }
        //     });
        //     dispatch({
        //         type: "UPDATE_STATE",
        //         payload: { name: "RequestExchange", value: "" }
        //     });


        // }
        // if (type == "rent") {
        //     dispatch({
        //         type: "UPDATE_STATE",
        //         payload: { name: "RequestSale", value: "" }
        //     });
        //     dispatch({
        //         type: "UPDATE_STATE",
        //         payload: { name: "RequestRent", value: "1" }
        //     });
        //     dispatch({
        //         type: "UPDATE_STATE",
        //         payload: { name: "RequestPreSale", value: "" }
        //     });
        //     dispatch({
        //         type: "UPDATE_STATE",
        //         payload: { name: "RequestAssociate", value: "" }
        //     });
        //     dispatch({
        //         type: "UPDATE_STATE",
        //         payload: { name: "RequestExchange", value: "" }
        //     });



        // }
        // if (type == "exchange") {
        //     dispatch({
        //         type: "UPDATE_STATE",
        //         payload: { name: "RequestSale", value: "" }
        //     });
        //     dispatch({
        //         type: "UPDATE_STATE",
        //         payload: { name: "RequestRent", value: "" }
        //     });
        //     dispatch({
        //         type: "UPDATE_STATE",
        //         payload: { name: "RequestPreSale", value: "" }
        //     });
        //     dispatch({
        //         type: "UPDATE_STATE",
        //         payload: { name: "RequestAssociate", value: "" }
        //     });
        //     dispatch({
        //         type: "UPDATE_STATE",
        //         payload: { name: "RequestExchange", value: "1" }
        //     });

        // }
        // if (type == "presale") {
        //     dispatch({
        //         type: "UPDATE_STATE",
        //         payload: { name: "RequestSale", value: "" }
        //     });
        //     dispatch({
        //         type: "UPDATE_STATE",
        //         payload: { name: "RequestRent", value: "" }
        //     });
        //     dispatch({
        //         type: "UPDATE_STATE",
        //         payload: { name: "RequestPreSale", value: "1" }
        //     });
        //     dispatch({
        //         type: "UPDATE_STATE",
        //         payload: { name: "RequestAssociate", value: "" }
        //     });
        //     dispatch({
        //         type: "UPDATE_STATE",
        //         payload: { name: "RequestExchange", value: "" }
        //     });


        // }
        // if (type == "associate") {
        //     dispatch({
        //         type: "UPDATE_STATE",
        //         payload: { name: "RequestSale", value: "" }
        //     });
        //     dispatch({
        //         type: "UPDATE_STATE",
        //         payload: { name: "RequestRent", value: "" }
        //     });
        //     dispatch({
        //         type: "UPDATE_STATE",
        //         payload: { name: "RequestPreSale", value: "" }
        //     });
        //     dispatch({
        //         type: "UPDATE_STATE",
        //         payload: { name: "RequestAssociate", value: "1" }
        //     });
        //     dispatch({
        //         type: "UPDATE_STATE",
        //         payload: { name: "RequestExchange", value: "" }
        //     });


        // }


    }, [])

    useEffect(() => {
        setShowSalePrice(wordifyfa(state.SalePrice))
        console.log("after update agency", state)

    }, [state.SalePrice])

    useEffect(() => {
        setShowSalePrice(wordifyfa(state.SalePrice))


    }, [state.SalePrice])


    const getLatLngHandle = () => {
        console.log("click")
    }

    // useEffect(() => {
    //     if (state.SalePrice == "") {
    //         if (state.Space != "") {
    //             if (BaseOnPrice == 0) {
    //                 if (meterPrice != "") {
    //                     console.log("meterPriceHandle", parseInt(state.Space) * parseInt(meterPrice))
    //                     dispatch({
    //                         type: "UPDATE_STATE",
    //                         payload: { name: "SalePrice", value: (parseInt(state.Space) * parseInt(meterPrice)).toString() }
    //                     });

    //                 }
    //                 else {
    //                     dispatch({
    //                         type: "UPDATE_STATE",
    //                         payload: { name: "SalePrice", value: "" }
    //                     });
    //                 }
    //             }
    //         }
    //         if (state.Infrastructure != "") {
    //             if (BaseOnPrice == 1) {
    //                 if (state.SalePrice != "") {
    //                     dispatch({
    //                         type: "UPDATE_STATE",
    //                         payload: { name: "SalePrice", value: (parseInt(state.Infrastructure) * parseInt(meterPrice)).toString() }
    //                     });
    //                 }
    //                 else {
    //                     dispatch({
    //                         type: "UPDATE_STATE",
    //                         payload: { name: "SalePrice", value: "" }
    //                     });
    //                 }
    //             }
    //         }
    //     }
    // }, [meterPrice])




    const handleOpenTypeZoneClose = () => {
        setOpenTypeZone(false);
        setTimeout(function () {
            if (document && typeof document.getElementById("areas-container") !== 'undefined' && document.getElementById("areas-container") !== null && areasItems.length > 0) {
                document.getElementById("areas-container").addEventListener('scroll', areaOnScroll)
                return () => document.getElementById("areas-container").removeEventListener('scroll', areaOnScroll)
            }
        }, 500)
    };

    const handleClickTypeZone = () => {
        setOpenTypeZone(true);
    };

    const formatJalali = (timestamp) => {
        console.log("timestamp", timestamp)
        try {
            return timestamp ? moment.unix(parseInt(timestamp / 1000)).format("jYYYY/jMM/jDD") : timestamp
        } catch (e) {
            console.log("error", e)
            return timestamp;
        }
    }

    return (


        <PageLayout title="ویرایش تقاضا">

            <Backdrop
                sx={{ color: '#fff', zIndex: 99999 }}
                open={openBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', pt: 3, px: 2, paddingBottom: '80px' }}>

                {/* <Box>
                        {
                            myContext ?
                            myContext.state.Pictures
                                :''
                        }
                    </Box> */}

                <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px', mt: 2, width: "100%" }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
                        <Box className="inputs-container flex-1" sx={{ display: 'flex', alignItems: 'center' }}>
                            <div className='flex-1 w-chile-100'>

                                <InputBase value={formatJalali(state.RegisterDate)} className='flex-1' onClick={() => setShowPicker(true)} placeholder='تاریخ ثبت' />
                                <Picker
                                    isOpen={showPicker}
                                    config={config}
                                    value={state.RegisterDate}
                                    initialValue={new Date(state.RegisterDate ? new Date(state.RegisterDate) : new Date())}
                                    minDate={newDate({ year: parseInt(moment().format("jYYYY")) - 100, month: 1, day: 1 })}
                                    maxDate={newDate({ year: parseInt(moment().format("jYYYY")), month: 12, day: 29 })}
                                    onSubmit={RegisterDateHandle}
                                    // onChange={RegisterDateHandle}
                                    onCancel={RegisterDateEmpty}
                                    onClose={() => setShowPicker(false)}
                                    highlightWeekends
                                />
                            </div>
                            <CalendarIcon />
                        </Box>

                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
                        <Box className="inputs-container flex-1" sx={{ display: 'flex', alignItems: 'center' }}>
                            <div className='flex-1 w-chile-100'>

                                <InputBase value={formatJalali(state.ExpireDate)} className='flex-1' onClick={() => setShowExpireDatePicker(true)} placeholder='تاریخ بازیابی' />

                                <Picker
                                    isOpen={showExpireDatePicker}
                                    config={config}
                                    initialValue={new Date(state.ExpireDate ? new Date(state.ExpireDate) : new Date())}
                                    minDate={newDate({ year: parseInt(moment().format("jYYYY")), month: 1, day: 1 })}
                                    maxDate={newDate({ year: parseInt(moment().format("jYYYY")) + 10, month: 12, day: 29 })}
                                    onSubmit={ExpireDateHandle}
                                    // onChange={ExpireDateHandle}
                                    onCancel={ExpireDateEmpty}
                                    onClose={() => setShowExpireDatePicker(false)}
                                    highlightWeekends
                                />
                            </div>
                            <CalendarIcon />
                        </Box>

                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
                        <Box className="inputs-container flex-1">
                            <InputBase placeholder='کد تقاضا' value={state.Row} type="number" onChange={RowHandle} />
                        </Box>
                        {/* <IconButton sx={{ backgroundColor: '#29A19C!important' }} onClick={handleClickOpenOpenCodeMelk}>
                            <CopyIcon />
                        </IconButton> */}
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }} className="requiredInput">
                        <Box className="inputs-container flex-1">
                            <InputBase placeholder='نام متقاضی' value={state.FullName} readOnly onChange={FullNameHandle} />
                        </Box>
                        <IconButton sx={{ backgroundColor: '#29A19C!important' }}>
                            <ContactIcon />
                        </IconButton>
                    </Box>
                    <Box>
                        <Box className="inputs-container" sx={{ display: "flex", width: 'auto', alignItems: "center" }}>
                            <InputBase placeholder='تلفن' readOnly className='flex-1' type="tel" inputProps={{ pattern: "\d*", maxlength: "11", dir: "rtl" }} value={state.Phone} onChange={PhoneHandle} />
                            <img src='/assets/img/phone.png' alt="" className='phoneImg' />
                        </Box>
                    </Box>
                    <Box className="requiredInput">
                        <Box className={`inputs-container flex-1 ${validation && validation.Mobile ? "error" : ''}`} sx={{ display: "flex", width: 'auto', alignItems: "center" }}>
                            <InputBase placeholder='شماره همراه' readOnly value={state.Mobile} type="tel" inputProps={{ pattern: "\d*", maxlength: "11", dir: "rtl" }} onChange={MobileHandle} />
                            <img src='/assets/img/mobile.png' alt="" sx={{ width: "14px" }} />
                        </Box>
                    </Box>
                    {validation && validation.Mobile ? <Typography variant='p' sx={{ color: '#d41d1d', fontSize: '12px', marginTop: '-10px' }}>شماره موبایل را بدرستی وارد کنید.</Typography> : ''}
                    {/* <Box>
                        <Box className="inputs-container" sx={{ width: 'auto' }}>
                            <InputBase placeholder='شماره تماس ساکن فعلی' type="number" className='flex-1' value={state.CurrentResidentPhoneNumber} onChange={CurrentResidentPhoneNumberHandle} />
                        </Box>
                    </Box> */}
                </Box>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px', mt: 4, width: '100%' }}>
                    <Typography className='f-16' gutterBottom sx={{ color: '#4A4949' }}>
                        نوع ملک
                    </Typography>
                    <Box className='tab-container'>
                        <Box>
                            <Tabs value={tabValue} onChange={handleChange} className="inputs-container" sx={{ width: 'auto', p: 0, display: 'flex' }} aria-label="basic tabs example">
                                <Tab icon={<CityIcon />} sx={{ flex: 1 }} iconPosition="start" label="شهری" {...a11yProps(0)} />
                                <Tab icon={<SettingIcon />} sx={{ flex: 1 }} iconPosition="start" label="صنعتی و کشاورزی" {...a11yProps(1)} />
                            </Tabs>
                        </Box>
                        <TabPanel value={tabValue} index={0}>
                            <Grid container spacing={5} className='gap-top-20' sx={{ pt: 2 }}>
                                {data.propertyType.cities.map((city, index) => (
                                    <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center', textAlign: 'center' }} key={index}>
                                        <input type="checkbox" name='propertyType' value={city} checked={state.PropertyTypes && state.PropertyTypes.includes(city)} id={`item${index}`} className="d-none typeCheck" onChange={PropertyTypeHandle} />
                                        <label htmlFor={`item${index}`} className='typeLabel w-100'>
                                            <span className="flex-1">{city}</span>
                                        </label>
                                    </Grid>
                                ))}
                                {/* {data.propertyType.map((melkItem, index) => (
                                    <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                        <input type="checkbox" id={`item${index}`} className="d-none typeCheck" />
                                        <label htmlFor={`item${index}`} className='typeLabel'>
                                            {melkItem}
                                        </label>
                                    </Grid>
                                ))} */}

                            </Grid>
                        </TabPanel>
                        <TabPanel value={tabValue} index={1}>
                            <Grid container spacing={5} className='gap-top-20' sx={{ pt: 2 }}>
                                {data.propertyType.industrial.map((industry, index) => (
                                    <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center', textAlign: 'center' }} key={index}>
                                        <input type="checkbox" name='propertyType' value={industry} checked={state.PropertyTypes && state.PropertyTypes.includes(industry)} id={`item${index}`} className="d-none typeCheck" onChange={PropertyTypeHandle} />
                                        <label htmlFor={`item${index}`} className='typeLabel w-100'>
                                            <span className="flex-1">{industry}</span>
                                        </label>
                                    </Grid>
                                ))}
                            </Grid>
                        </TabPanel>
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px', mt: 2, width: '100%' }}>
                    <Typography className='f-16' gutterBottom sx={{ color: '#4A4949' }}>
                        {userInfo.LocationName}
                    </Typography>
                    <Box sx={{ width: '100%' }}>
                        <Box onClick={handleClickOpenZoneModal} className={`inputs-container ${state.Areas && state.Areas.length ? 'checked' : ''}`} sx={{ display: 'flex', width: 'auto', alignItems: 'center', cursor: 'pointer', justifyContent: 'space-between', }}>
                            {/* <InputBase onChange={PropertyAreaHandle} type="text" placeholder='محدوده' />
                            <Box onClick={handleClickOpenZoneModal} sx={{
                                width: '20px !important',
                                height: '20px !important',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                {
                                    state.Areas.length ? null :
                                        <PlusIcon width="13" height="13" />}
                            </Box> */}
                            <Box className="overflow-three-line">
                                <Box>
                                    {state.Areas && state.Areas.length ? state.Areas.map((item, index) => {
                                        return <span key={index}>{item} {index != state.Areas.length - 1 && "،"} </span>
                                    }) : "محدوده"}
                                </Box>
                            </Box>
                            {
                                state.Areas && state.Areas.length ? null :
                                    <PlusIcon width="13" height="13" />}
                        </Box>
                    </Box>
                    {/* {
                        state.Areas.length && <Box sx={{ display: 'flex', gap: "5px" }}>
                            {state.Areas.map((item, index) => {
                                return <Box sx={{ bgcolor: '#29a19c', borderRadius: "5px", color: "#fff", p: "5px" }} key={index}>{item}</Box>
                            })}
                        </Box>
                    } */}
                    {/* <Box sx={{ width: '100%' }}>
                        <Box className="inputs-container" sx={{ width: 'auto' }}>
                            <InputBase placeholder='آدرس' className='flex-1' value={state.Address} onChange={AddressHandle} />
                        </Box>
                    </Box> */}
                    {/* <Box>
                        <Button className='green-btn' sx={{ borderRadius: '50px', px: 5, py: 1, fontSize: '15px' }} onClick={handleClickOpenMapModal}>
                            نقشه
                        </Button>
                    </Box> */}
                    <Box sx={{ width: '100%' }}>
                        <label htmlFor='meter' className='f-16 text-label'>متراژ زیربنا (متر مربع)</label>
                        <Box className="inputs-container" sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }} onClick={handleClickSelectMeterModal}>
                            {/* <InputBase id='meter' onChange={InfrastructureHandle} type="number" value={state.Infrastructure} /> */}
                            <span>
                                {state.MinInfrastructure ? state.MinInfrastructure : ""}
                                {state.MinInfrastructure && state.MaxInfrastructure ? " , " : ""}
                                {state.MaxInfrastructure ? state.MaxInfrastructure : ""}
                            </span>
                            <ArrowRightIcon className='rotate-180-minus' />
                        </Box>
                    </Box>
                    <Box sx={{ width: '100%' }}>
                        <label htmlFor='meter' className='f-16 text-label'>متراژ مساحت (متر مربع)</label>
                        <Box className="inputs-container" sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }} onClick={handleClickSelectSpaceModal}>
                            {/* <InputBase id='meter' onChange={SpaceHandle} type="number" value={state.Space} /> */}
                            <span>
                                {state.MinSpace ? state.MinSpace : ""}
                                {state.MinSpace && state.MaxSpace ? " , " : ""}
                                {state.MaxSpace ? state.MaxSpace : ""}
                            </span>
                            <ArrowRightIcon className='rotate-180-minus' />
                        </Box>
                    </Box>
                    <Box sx={{ width: '100%' }}>
                        <label className='f-16 text-label'>تعداد اتاق</label>
                        <Box className="inputs-container" sx={{ width: 'auto', mt: 1, overflow: "hidden" }}>
                            <Box className="numbers-scroll" sx={{ width: '100%', display: 'flex', direction: 'ltr', justifyContent: 'start', textAlign: 'center', overflow: "auto" }}>

                                {
                                    Array.apply(0, Array(51)).map(function (x, i) {
                                        return <Box key={i}>
                                            <input type="checkbox" name='countRoom' id={`roomcount${i}`} value={i} checked={state.MinRoomsCount && state.MinRoomsCount.includes(i.toString())} onChange={RoomsCountHandle} className="d-none NumberCheck" />
                                            <label htmlFor={`roomcount${i}`} className='NumberLabel'>
                                                {i}
                                            </label>
                                        </Box>
                                    })
                                }
                            </Box>
                        </Box>
                    </Box>
                    <Box sx={{ width: '100%' }}>
                        <label className='f-16 text-label'>طبقه</label>
                        <Box className="inputs-container" sx={{ width: 'auto', mt: 1, overflow: "hidden" }}>
                            <Box className="numbers-scroll" id="floorNo-container" sx={{ width: '100%', display: 'flex', direction: 'ltr', justifyContent: 'start', textAlign: 'center', overflow: "auto" }}>

                                {
                                    Array.apply(0, Array(51)).map(function (x, i) {
                                        return <Box key={i}>
                                            <input type="checkbox" name='floor' id={`floor${i - 25}`} value={i - 25} checked={state.floors && state.floors != "" && state.floors.includes((i - 25).toString())} onChange={FloorsHandle} className="d-none NumberCheck" />
                                            <label htmlFor={`floor${i - 25}`} className='NumberLabel'>
                                                {i - 25 == 0 ? <span style={{ fontSize: "10px" }}>همکف</span> : i - 25}
                                            </label>
                                        </Box>
                                    })
                                }
                            </Box>
                        </Box>
                    </Box>
                    {/* <Box sx={{ width: '100%' }}>
                        <label className='f-16 text-label'>تعداد طبقات</label>
                        <Box className="inputs-container" sx={{ width: 'auto', mt: 1, overflow: "hidden" }}>
                            <Box className="numbers-scroll" sx={{ width: '100%', display: 'flex', direction: 'ltr', justifyContent: 'start', textAlign: 'center', overflow: "auto" }}>

                                {
                                    Array.apply(0, Array(51)).map(function (x, i) {
                                        return <Box key={i}>
                                            <input type="radio" name='floorCount' id={`floorCount${i + 1}`} value={i + 1} checked={state.StoreyCount == i + 1} onChange={StoreyCountHandle} className="d-none NumberCheck" />
                                            <label htmlFor={`floorCount${i + 1}`} className='NumberLabel'>
                                                {i + 1}
                                            </label>
                                        </Box>
                                    })
                                }
                            </Box>
                        </Box>
                    </Box> */}
                    <Grid container>
                        <Grid item xs={6}>
                            <FormControlLabel className='green-check' sx={{ mr: 0 }} control={<Checkbox defaultChecked />} checked={state.ShortTermRent == "" ? false : true} onChange={(e) => handleChangeRadio("ShortTermRent", e)} label="اجاره کوتاه مدت" />
                        </Grid>
                        <Grid item xs={6}>
                            <FormControlLabel className='green-check' sx={{ mr: 0 }} control={<Checkbox defaultChecked />} checked={state.OwnerShouldNotResident == "" ? false : true} onChange={(e) => handleChangeRadio("OwnerShouldNotResident", e)} label="مالک ساکن نباشد" />
                        </Grid>
                    </Grid>

                    {/* <Box>
                        <label className='f-16 text-label'>تعداد واحد در طبقه</label>
                        <Box className="inputs-container" sx={{ width: 'auto', mt: 1, display: 'flex', direction: 'ltr', justifyContent: 'space-around', textAlign: 'center' }}>
                            {
                                Array.apply(0, Array(10)).map(function (x, i) {
                                    return <Box key={i}>
                                        <input type="radio" name='countInFloor' id={`countInFloor${i}`} value={i + 1} checked={state.UnitsCount == i + 1} onChange={UnitsCountHandle} className="d-none NumberCheck" />
                                        <label htmlFor={`countInFloor${i}`} className='NumberLabel'>
                                            {i + 1}
                                        </label>
                                    </Box>
                                })
                            }
                        </Box>
                    </Box> */}
                    {/* <Box>
                        <Box onClick={handleClickOpenFloorModal} className={`inputs-container ${state.Floors.length ? 'checked' : ''}`} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                            ثبت طبقات
                            {
                                state.Floors.length ? null :
                                    <PlusIcon width="13" height="13" />}
                        </Box>
                    </Box> */}
                    {
                        state.RequestSale == 1 ?
                            <Box>
                                <FormControlLabel className='green-check' sx={{ mr: 0 }} control={<Checkbox defaultChecked />} checked={showLoan} onChange={() => setShowLoan(!showLoan)} label="ملک دارای وام می باشد" />
                            </Box>
                            : null
                    }
                    {
                        showLoan ?
                            <Box>
                                <label htmlFor='meter' className='f-16 text-label'>میزان وام ملک</label>
                                <Box className="inputs-container" sx={{ width: 'auto', mt: 1 }}>
                                    <InputBase id='meter' type="number" onChange={LoanPriceHandle} value={state.LoanPrice} />
                                </Box>
                            </Box>
                            :
                            null
                    }

                    <Box sx={{ display: 'flex', gap: 1, flexDirection: 'column' }}>
                        <label className='f-16 text-label'>نوع کاربری</label>
                        <Grid container spacing={5} sx={{ pt: 2 }} className='gap-top-20'>
                            {data.AccountType.map((AccountTypeKey, index) => (
                                <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                    <input type="checkbox" id={`AccountType${index}`} value={AccountTypeKey} checked={state.UsageTypes && state.UsageTypes.includes(AccountTypeKey)} onChange={AccountTypeKeyHandel} className="d-none typeCheck" />
                                    <label htmlFor={`AccountType${index}`} className='typeLabel'>
                                        {AccountTypeKey}
                                    </label>
                                </Grid>
                            ))}

                        </Grid>
                    </Box>
                    <Box onClick={handleClickOpenEmkanatModal} className={`inputs-container ${state.Facilities && state.Facilities.length ? 'checked' : ''}`} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                        {state.Facilities && !state.Facilities.length ? "امکانات" :
                            <Box className="overflow-three-line">
                                <Box>
                                    {state.Facilities && state.Facilities.length ? state.Facilities.map((item, index) => {
                                        return <span key={index}>{propFacilities[item]} {index != state.Facilities.length - 1 && "،"} </span>
                                    }) : ""}
                                </Box>
                            </Box>}
                        {
                            state.Facilities && state.Facilities && state.Facilities.length ? null :
                                <PlusIcon width="13" height="13" />}
                    </Box>
                    <Box onClick={handleClickOpenPropertyModal} className={`inputs-container ${state.Store != "0" && state.Store != "" || state.Elec3Phase != "0" && state.Elec3Phase != "" || state.Elevator != "0" && state.Elevator != "" || state.Parking != "0" && state.Parking != "" || state.Court != "0" && state.Court != "" || state.IsNotImpasse != "0" && state.IsNotImpasse != "" || state.InputSeparate != "0" && state.InputSeparate != "" || state.MustHaveCommercial != "0" && state.MustHaveCommercial != "" ? 'checked' : ''}`} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                        {state.Store != "0" && state.Store != "" || state.Elec3Phase != "0" && state.Elec3Phase != "" || state.Elevator != "0" && state.Elevator != "" || state.Parking != "0" && state.Parking != "" || state.Court != "0" && state.Court != "" || state.IsNotImpasse != "0" && state.IsNotImpasse != "" || state.InputSeparate != "0" && state.InputSeparate != "" || state.MustHaveCommercial != "0" && state.MustHaveCommercial != "" ?
                            <Box className="overflow-three-line">
                                <Box>
                                    {state.Store != "" && state.Store != "0" && <span>{data.mainFeatures.Store} ، </span>}
                                    {state.Elec3Phase != "" && state.Elec3Phase != "0" && <span>{data.mainFeatures.Elec3Phase} ، </span>}
                                    {state.Elevator != "" && state.Elevator != "0" && <span>{data.mainFeatures.Elevator} ، </span>}
                                    {state.Parking != "" && state.Parking != "0" && <span>{data.mainFeatures.Parking} ، </span>}
                                    {state.Yard != "" && state.Yard != "0" && <span>{data.mainFeatures.Yard} ، </span>}
                                    {state.IsNotImpasse != "" && state.IsNotImpasse != "0" && <span>{data.mainFeatures.IsNotImpasse} ، </span>}
                                    {state.InputSeparate != "" && state.InputSeparate != "0" && <span>{data.mainFeatures.InputSeparate} ، </span>}
                                    {state.MustHaveCommercial != "" && state.MustHaveCommercial != "0" && <span>{data.mainFeatures.MustHaveCommercial} ، </span>}
                                </Box>
                            </Box> : "ویژگی های اصلی"}
                        {
                            state.Store != "0" && state.Store != "" || state.Elec3Phase != "0" && state.Elec3Phase != "" || state.Elevator != "0" && state.Elevator != "" || state.Parking != "0" && state.Parking != "" || state.Court != "0" && state.Court != "" || state.IsNotImpasse != "0" && state.IsNotImpasse != "" || state.InputSeparate != "0" && state.InputSeparate != "" || state.MustHaveCommercial != "0" && state.MustHaveCommercial != "" ? null :
                                <PlusIcon width="13" height="13" />}
                    </Box>
                    <Box>
                        <label className='f-16 text-label d-block mb-2'>امتیازات</label>
                        <label className='f-16'>آب</label>
                        <Grid container spacing={1}>

                            <Grid item xs={4}>
                                <input type='radio' name="emtiaz2Item" value="مستقل" onChange={WaterHandle} onClick={disWaterHandle} checked={state.Water != "" && state.Water == "مستقل"} className='d-none typeCheck' id='emtiaz2Item1' />
                                <label className="typeLabel w-auto text-center" htmlFor='emtiaz2Item1'>
                                    <span className='flex-1'>مستقل</span>
                                </label>
                            </Grid>
                            <Grid item xs={4}>
                                <input type='radio' name="emtiaz2Item" value="دارد" onChange={WaterHandle} onClick={disWaterHandle} checked={state.Water != "" && state.Water == "دارد"} className='d-none typeCheck' id='emtiaz2Item2' />
                                <label className="typeLabel w-auto text-center" htmlFor='emtiaz2Item2'>
                                    <span className='flex-1'>دارد</span>
                                </label>
                            </Grid>
                            <Grid item xs={4}>
                                <input type='radio' name="emtiaz2Item" value="مهم نیست" onChange={WaterHandle} onClick={disWaterHandle} checked={state.Water != "" && state.Water == "مهم نیست"} className='d-none typeCheck' id='emtiaz2Item3' />
                                <label className="typeLabel w-auto text-center" htmlFor='emtiaz2Item3'>
                                    <span className='flex-1'>مهم نیست</span>
                                </label>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box>
                        <label className='f-16'>برق</label>
                        <Grid container spacing={1}>
                            <Grid item xs={4}>
                                <input type='radio' name="emtiazBarghItem" value="مستقل" onChange={ElectricityHandle} onClick={disElectricityHandle} checked={state.Electricity != "" && state.Electricity == "مستقل"} className='d-none typeCheck' id='emtiazBarghItem1' />
                                <label className="typeLabel w-auto" htmlFor='emtiazBarghItem1'>
                                    <span className='flex-1'>مستقل</span>
                                </label>
                            </Grid>
                            <Grid item xs={4}>
                                <input type='radio' name="emtiazBarghItem" value="دارد" onChange={ElectricityHandle} onClick={disElectricityHandle} checked={state.Electricity != "" && state.Electricity == "دارد"} className='d-none typeCheck' id='emtiazBarghItem2' />
                                <label className="typeLabel w-auto" htmlFor='emtiazBarghItem2'>
                                    <span className='flex-1'>دارد</span>

                                </label>
                            </Grid>
                            <Grid item xs={4}>
                                <input type='radio' name="emtiazBarghItem" value="مهم نیست" onChange={ElectricityHandle} onClick={disElectricityHandle} checked={state.Electricity != "" && state.Electricity == "مهم نیست"} className='d-none typeCheck' id='emtiazBarghItem3emtiazGaz' />
                                <label className="typeLabel w-auto" htmlFor='emtiazBarghItem3emtiazGaz'>
                                    <span className='flex-1'>مهم نیست</span>
                                </label>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box>
                        <label className='f-16'>گاز</label>
                        <Grid container spacing={1}>

                            <Grid item xs={4}>
                                <input type='radio' name="emtiazGaz" className='d-none typeCheck' id='emtiazGaz1' value="مستقل" onChange={GasHandle} onClick={disGasHandle} checked={state.Gas != "" && state.Gas == "مستقل"} />
                                <label className="typeLabel w-auto" htmlFor='emtiazGaz1'>
                                    <span className='flex-1'>مستقل</span>
                                </label>
                            </Grid>
                            <Grid item xs={4}>
                                <input type='radio' name="emtiazGaz" className='d-none typeCheck' id='emtiazGaz2' value="دارد" onChange={GasHandle} onClick={disGasHandle} checked={state.Gas != "" && state.Gas == "دارد"} />
                                <label className="typeLabel w-auto" htmlFor='emtiazGaz2'>
                                    <span className='flex-1'>دارد</span>
                                </label>
                            </Grid>
                            <Grid item xs={4}>
                                <input type='radio' name="emtiazGaz" className='d-none typeCheck' id='emtiazGaz3' value="مهم نیست" onChange={GasHandle} onClick={disGasHandle} checked={state.Gas != "" && state.Gas == "مهم نیست"} />
                                <label className="typeLabel w-auto" htmlFor='emtiazGaz3'>
                                    <span className='flex-1'>مهم نیست</span>
                                </label>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box>
                        <label className='f-16 text-label'>سال ساخت</label>
                        <Box onClick={handleOpenYearCreatedModal} className={`inputs-container ${yearSlected && yearSlected != "" ? "checked" : ""} `} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                            <Box className="overflow-three-line">
                                <Box>
                                    {yearSlected != "" && nowDate - yearSlected != 0 ? `${yearSlected} (${nowDate - yearSlected} سال ساخت)` : yearSlected}
                                </Box>
                            </Box>
                            {yearSlected && yearSlected != "" ? null : <PlusIcon width="13" height="13" />}
                        </Box>
                    </Box>
                    <Box>
                        <label className='f-16 text-label'>وضعیت بنا</label>
                        <Grid container spacing={1}>
                            <Grid item xs={4}>
                                <input type='checkbox' name="buildStats" className='d-none typeCheck' id='buildStats1' value="نوساز" onChange={EstateStatusHandle} />
                                <label className="typeLabel w-auto" htmlFor='buildStats1'>
                                    <span className='flex-1'>نوساز</span>
                                </label>
                            </Grid>
                            <Grid item xs={4}>
                                <input type='checkbox' name="buildStats" className='d-none typeCheck' id='buildStats2' value="بازسازی شده" onChange={EstateStatusHandle} />
                                <label className="typeLabel w-auto" htmlFor='buildStats2'>
                                    <span className='flex-1'>بازسازی شده</span>

                                </label>
                            </Grid>
                            <Grid item xs={4}>
                                <input type='checkbox' name="buildStats" className='d-none typeCheck' id='buildStats3' value='قدیمی' onChange={EstateStatusHandle} />
                                <label className="typeLabel w-auto" htmlFor='buildStats3'>
                                    <span className='flex-1'>قدیمی</span>
                                </label>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box>
                        <label className='f-16 text-label'>تراکم</label>
                        <Grid container spacing={1}>
                            <Grid item xs={4}>
                                <input type='checkbox' name="tarakom" className='d-none typeCheck' id='tarakom1' onChange={AggregationHandle} value='کم' />
                                <label className="typeLabel w-auto" htmlFor='tarakom1'>
                                    <span className='flex-1'>کم</span>
                                </label>
                            </Grid>
                            <Grid item xs={4}>
                                <input type='checkbox' name="tarakom" className='d-none typeCheck' id='tarakom2' onChange={AggregationHandle} value='متوسط' />
                                <label className="typeLabel w-auto" htmlFor='tarakom2'>
                                    <span className='flex-1'>متوسط</span>

                                </label>
                            </Grid>
                            <Grid item xs={4}>
                                <input type='checkbox' name="tarakom" className='d-none typeCheck' id='tarakom3' onChange={AggregationHandle} value='زیاد' />
                                <label className="typeLabel w-auto" htmlFor='tarakom3'>
                                    <span className='flex-1'>زیاد</span>
                                </label>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box>
                        <label className='f-16 text-label'>نوع سند</label>
                        <Box onClick={handleClickOpenSanadModal} className={`inputs-container ${state.CertificateType && state.CertificateType.length ? 'checked' : ''}`} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                            <Box className="overflow-three-line">
                                <Box>
                                    {state.CertificateType && state.CertificateType.length ? state.CertificateType.map((item, index) => {
                                        return <span key={index}>{item} {index != state.CertificateType.length - 1 && "،"} </span>
                                    }) : ""}
                                </Box>
                            </Box>
                            {state.CertificateType && state.CertificateType.length ? null : <PlusIcon width="13" height="13" />}
                        </Box>
                    </Box>
                    {/* <Box>
                        <label className='f-16 text-label'>جهت</label>

                        <Box onClick={handleClickOpenJahatModal} className={`inputs-container ${state.Direction && state.Direction.length ? 'checked' : ''}`} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                            <span></span>
                            {state.Direction && state.Direction.length ? null : <PlusIcon width="13" height="13" />}
                        </Box>
                    </Box>
                    <Box>
                        <label className='f-16 text-label'>نما</label>

                        <Box onClick={handleClickOpenNamaModal} className={`inputs-container ${state.Frontage && state.Frontage.length ? 'checked' : ''}`} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                            <snap></snap>
                            {state.Frontage && state.Frontage.length ? null : <PlusIcon width="13" height="13" />}
                        </Box>
                    </Box>
                    <Box>
                        <label className='f-16 text-label'>کفپوش</label>

                        <Box onClick={handleClickOpenKafpooshModal} className={`inputs-container ${state.Floor && state.Floor.length ? 'checked' : ''}`} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                            <span></span>
                            {state.Floor && state.Floor.length ? null : <PlusIcon width="13" height="13" />}

                        </Box>
                    </Box>
                    <Box>
                        <label className='f-16 text-label'>سرمایش</label>

                        <Box onClick={handleClickOpenSarmayeshModal} className={`inputs-container ${state.Cooling && state.Cooling.length ? 'checked' : ''}`} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                            <span></span>
                            {state.Cooling && state.Cooling.length ? null : <PlusIcon width="13" height="13" />}
                        </Box>
                    </Box>
                    <Box>
                        <label className='f-16 text-label'>گرمایش</label>

                        <Box onClick={handleClickOpenGarmayeshModal} className={`inputs-container ${state.Heating && state.Heating.length ? 'checked' : ''}`} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                            <span></span>
                            {state.Heating && state.Heating.length ? null : <PlusIcon width="13" height="13" />}
                        </Box>
                    </Box>
                    <Box>
                        <label className='f-16 text-label'>سرویس آشپزخانه</label>

                        <Box onClick={handleClickOpenKitchenhModal} className={`inputs-container ${state.KitchenService && state.KitchenService.length ? 'checked' : ''}`} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                            <span></span>
                            {state.KitchenService && state.KitchenService.length ? null : <PlusIcon width="13" height="13" />}
                        </Box>
                    </Box> */}
                    {/* {
                        type == 'sale' ?
                            <Box>
                                <label className='f-16 text-label'>مبلغ خرید</label>
                                <Box className="inputs-container" sx={{ width: 'auto', p: 0 }}>
                                    <Grid container>
                                        <Grid item xs={5} sx={{ borderLeft: 'solid 1px', padding: '10px' }}>
                                            <select
                                                labelid="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={state.PriceCalcMode ? state.PriceCalcMode : ''}
                                                onInput={handleChangeBaseOnPrice}
                                                className="select-control"
                                            >
                                                <option selected value="Infrastructure">بر اساس زیر بنا</option>

                                                <option value="Space">بر اساس مساحت</option>
                                            </select>
                                        </Grid>
                                        <Grid item xs={7} sx={{ padding: '10px' }}>
                                            
                                            <TextField
                                                label=""
                                                value={meterPrice} onChange={meterPriceHandle}
                                                name="numberformat"
                                                pattern="(\d)+"

                                                id="formatted-numberformat-input"
                                                className='remove-underline dir-ltr w-100'
                                                InputProps={{
                                                    inputComponent: NumericFormatCustom,
                                                }}
                                                variant="standard"
                                            />
                                        </Grid>
                                    </Grid>
                                </Box>

                            </Box>
                            : null
                    } */}

                    {
                        state.RequestSale == 1 ?
                            <Box sx={{ width: '100%' }}>
                                <label htmlFor='meter' className='f-16 text-label'>مبلغ خرید <span className='text-gray'>(تومان)</span></label>
                                <Box className="inputs-container" onClick={handleClickTmpSalePriceModal} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                                    <span>
                                        {state.MinSalePrice ? parseInt(state.MinSalePrice).toLocaleString() : ""}
                                        {state.MinSalePrice && state.MaxSalePrice ? " , " : ""}
                                        {state.MaxSalePrice ? parseInt(state.MaxSalePrice).toLocaleString() : ""}
                                    </span>
                                    <ArrowRightIcon className='rotate-180-minus' />
                                </Box>
                            </Box>
                            : null
                    }

                    {
                        state.RequestRent == 1 ?
                            <Box>
                                <label className='f-16 text-label'>ارجحیت اجاره</label>
                                <Box onClick={handleClickRentPrefereModal} className={`inputs-container ${state.RentPrefer && state.RentPrefer.length ? 'checked' : ''}`} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                                    <Box className="overflow-three-line">
                                        <Box>
                                            {state.RentPrefer && state.RentPrefer.length ? state.RentPrefer.map((item, index) => {
                                                return <span key={index}>{item} {index != state.RentPrefer.length - 1 && "،"} </span>
                                            }) : ""}
                                        </Box>
                                    </Box>
                                    {state.RentPrefer && state.RentPrefer.length ? null : <PlusIcon width="13" height="13" />}
                                </Box>
                            </Box> : null}

                    {
                        state.RequestRent == 1 ?
                            <Box sx={{ width: '100%' }}>
                                <label htmlFor='meter' className='f-16 text-label'>مبلغ رهن <span className='text-gray'>(تومان)</span></label>
                                <Box className="inputs-container" onClick={handleClickTmpMortgagePriceModal} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                                    <span>
                                        {state.MinMortgagePrice ? parseInt(state.MinMortgagePrice).toLocaleString() : ""}
                                        {state.MinMortgagePrice && state.MaxMortgagePrice ? " , " : ""}
                                        {state.MaxMortgagePrice ? parseInt(state.MaxMortgagePrice).toLocaleString() : ""}
                                    </span>
                                    <ArrowRightIcon className='rotate-180-minus' />
                                </Box>
                            </Box> : null}
                    {
                        state.RequestRent == 1 ?
                            <Box sx={{ width: '100%' }}>
                                <label htmlFor='meter' className='f-16 text-label'>مبلغ اجاره <span className='text-gray'>(تومان)</span></label>
                                <Box className="inputs-container" onClick={handleClickTmpRentPriceModal} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                                    <span>
                                    {state.MinRentPrice ? parseInt(state.MinRentPrice).toLocaleString() : ""}
                                        {state.MinRentPrice && state.MaxRentPrice ? " , " : ""}
                                        {state.MaxRentPrice ? parseInt(state.MaxRentPrice).toLocaleString() : ""}
                                    </span>
                                    <ArrowRightIcon className='rotate-180-minus' />
                                </Box>
                            </Box> : null}

                    <Box>
                        <label className='f-16 text-label'>توضیحات عمومی</label>
                        <Box className='inputs-container' sx={{ width: 'auto' }}>
                            <TextareaAutosize
                                aria-label="minimum height"
                                minRows={3}
                                onChange={PublicDescriptionHandle}
                                value={state.PublicDescription}
                                style={{ width: '100%', border: '0px' }}
                            />
                        </Box>
                    </Box>
                    <Box>
                        <label className='f-16 text-label'>توضیحات خصوصی</label>
                        <Box className='inputs-container' sx={{ width: 'auto' }}>
                            <TextareaAutosize
                                aria-label="minimum height"
                                minRows={3}
                                onChange={DescriptionHandle}
                                value={state.Description}
                                style={{ width: '100%', border: '0px' }}
                            />
                        </Box>
                    </Box>
                </Box>
                {
                    state.RequestSale == 1 ?
                        state.Mobile && state.Mobile != '' && state.FullName && state.FullName != '' ?
                            <Button className='green-btn' onClick={handleEditDemand} sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px', padding: '10px', zIndex: '11' }}>ویرایش</Button>
                            :
                            <Button className='gray-btn f-17' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px', padding: '10px', zIndex: '11', display: 'flex', gap: '5px' }}>گزینه های ستاره دار <StarIcon width="10" height="10" /> پر شود</Button>
                        :
                        state.Mobile && state.Mobile != '' && state.FullName && state.FullName != '' ?
                            <Button className='green-btn' onClick={handleEditDemand} sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px', padding: '10px', zIndex: '11' }}>ویرایش</Button>
                            :
                            <Button className='gray-btn f-17' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px', padding: '10px', zIndex: '11', display: 'flex', gap: '5px' }}>گزینه های ستاره دار <StarIcon width="10" height="10" /> پر شود</Button>

                }



                {openEmkanatModal && <Dialog className="dialog-box"
                    fullScreen
                    open={openEmkanatModal}
                    onClose={handleEmkanatClose}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>

                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                                امکانات
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleEmkanatClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                        </Toolbar>
                    </AppBar>
                    <Box sx={{ px: 2, color: '#8F8F8F', display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px', paddingBottom: '70px' }}>
                        <Box sx={{ px: 1, mt: 3, color: '#8F8F8F', display: 'flex', flexDirection: 'column', gap: '15px' }}>
                            <Grid container spacing={3} sx={{ pt: 2 }} className='gap-top-20'>
                                {Object.keys(propFacilities).map((facilitiesKey, index) => (
                                    <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                        <input type="checkbox" id={`facilities${index}`} className="d-none typeCheck" value={facilitiesKey} onChange={FacilitiesHandel} checked={state.Facilities && state.Facilities.includes(facilitiesKey)} />
                                        <label htmlFor={`facilities${index}`} className='typeLabel'>
                                            {propFacilities[facilitiesKey]}
                                        </label>
                                    </Grid>
                                ))}

                            </Grid>

                        </Box>
                    </Box>
                    <Button className='green-btn'
                        onClick={handleEmkanatClose}
                        sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
                </Dialog>}

                {openProperty && <Dialog className="dialog-box"
                    fullScreen
                    open={openProperty}
                    onClose={handleProperyClose}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>

                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                                ویژگی های اصلی
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleProperyClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                        </Toolbar>
                    </AppBar>

                    <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', display: 'flex', overflowX: 'hidden', flexWrap: 'wrap', flexDirection: 'column', gap: '15px', paddingBottom: '70px' }}>

                        <Grid container spacing={4} sx={{ pt: 2 }} className='gap-top-20'>
                            {Object.keys(data.mainFeatures).map((feature, index) => (
                                <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                    <input type="checkbox" id={`feature${index}`} className="d-none typeCheck" value={feature} onChange={featureHandle} />
                                    <label htmlFor={`feature${index}`} className='typeLabel'>
                                        {data.mainFeatures[feature]}
                                    </label>
                                </Grid>
                            ))}
                        </Grid>

                    </Box>

                    <Button className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}
                        onClick={handleProperyClose}
                    >انتخاب</Button>
                </Dialog>}

                {openZoneModal && <Dialog className="dialog-box"
                    fullScreen
                    open={openZoneModal}
                    onClose={handleClose}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>
                            <IconButton autoFocus color="inherit" onClick={handleClickTypeZone}>
                                <SettingIcon />
                            </IconButton>
                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                                انتخاب محدوده
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                        </Toolbar>
                    </AppBar>
                    <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', height: "calc(100vh - 120px)!important", overflow: 'auto' }} id="areas-container">
                        <Box className="inputs-container" sx={{ display: "flex", width: 'auto', alignItems: "center", border: '0px', bgcolor: '#EEEBEB' }}>
                            <InputBase placeholder='محدوده یا محله مورد نظر خود را وارد کنید' className='flex-1' onChange={areasSearchHandle} />
                            <IconButton>
                                <SreachIcon />
                            </IconButton>
                        </Box>
                        <Box sx={{ px: 1, mt: 3, color: '#8F8F8F', display: 'flex', flexDirection: 'column', gap: '15px', paddingBottom: '70px', height: "100%" }}>
                            <Grid container spacing={3}>

                                {
                                    areasItems && areasItems.length > 0 ?
                                        areasItems.map((item, index) => (

                                            <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                                <input type="checkbox" id={`areas${index}`} value={item.Name} onChange={PropertyAreaHandle} checked={state.Areas && state.Areas.includes(item.Name)} className="d-none typeCheck" />
                                                <label htmlFor={`areas${index}`} className='typeLabel'>
                                                    {item.Name}
                                                </label>
                                            </Grid>
                                        ))
                                        : !areasLoading ? <Box sx={{ textAlign: 'center', mt: 2, width: '100%' }}>موردی یافت نشد!</Box> : ""
                                }
                                {
                                    areasLoading ? <Box sx={{ textAlign: 'center', width: "100%", p: 2 }}>درحال بارگیری...</Box> : ""

                                }
                            </Grid>
                        </Box>
                    </Box>
                    <Button
                        onClick={handleClose}
                        className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
                </Dialog>}
                {openSanadModal && <Dialog className="dialog-box"
                    fullScreen
                    open={openSanadModal}
                    onClose={handleCloseSanadModal}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>

                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                                انتخاب کنید
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleCloseSanadModal}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                        </Toolbar>
                    </AppBar>
                    <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px' }}>
                        <Box className="inputs-container" sx={{ display: "flex", width: 'auto', alignItems: "center" }}>
                            <InputBase placeholder='' className='flex-1' />
                            <IconButton>
                                <SreachIcon />
                            </IconButton>
                        </Box>
                        <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', display: 'flex', flexDirection: 'column', gap: '15px', paddingBottom: '70px' }}>
                            <Grid container spacing={4}>
                                {data.typeDoc.map((doc, index) => (
                                    <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                        <input type="checkbox" name="sanad" id={`sanad${index}`} className="d-none typeCheck" checked={state.CertificateType && state.CertificateType.includes(doc)} value={doc} onChange={CertificateTypeHandle} />
                                        <label htmlFor={`sanad${index}`} className='typeLabel'>
                                            {doc}
                                        </label>
                                    </Grid>
                                ))}
                            </Grid>
                        </Box>
                    </Box>
                    <Button
                        onClick={handleCloseSanadModal}
                        className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
                </Dialog>}





                {openKitchenModal && <Dialog className="dialog-box"
                    fullScreen
                    open={openKitchenModal}
                    onClose={handleCloseKitchenModal}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>

                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                                انتخاب کنید
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleCloseKitchenModal}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                        </Toolbar>
                    </AppBar>
                    <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px' }}>
                        <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', display: 'flex', flexDirection: 'column', gap: '15px' }}>
                            <Grid container spacing={4}>
                                {data.kitchen.map((kitchen, index) => (
                                    <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                        <input type="radio" id={`kitchen${index}`} className="d-none floorCheck" value={kitchen} name="kitchen" onChange={KitchenServiceHandle} />
                                        <label htmlFor={`kitchen${index}`} className='floorLabel inputs-container w-100'>
                                            <div>{kitchen}</div>
                                        </label>
                                    </Grid>
                                ))}

                            </Grid>

                        </Box>
                    </Box>
                    <Button className='green-btn'
                        onClick={handleCloseKitchenModal}
                        sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
                </Dialog>}
                {/* {openMapModal && <Dialog className="dialog-box"
                    fullScreen
                    open={openMapModal}
                    onClose={handleCloseMapModal}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>

                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                                انتخاب کنید
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleCloseMapModal}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                             
                        </Toolbar>
                    </AppBar>
                    <Box sx={{ mt: 3, color: '#8F8F8F', display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px', paddingBottom: '50px', height: '100%' }}>

                        <MapContainer center={positionMap} zoom={13} scrollWheelZoom={false} className="h-100" onClick={getLatLngHandle}>
                            <TileLayer
                                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            />
                            <LocationMarker LatLongHandle={LatLongHandle} />

                        </MapContainer>
                    </Box>

                    <Button className='green-btn'
                        onClick={handleCloseMapModal}
                        sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
                </Dialog>} */}
                {floorNumModal && <Dialog className="dialog-box"
                    fullScreen
                    open={floorNumModal}
                    onClose={handleCloseFloorNumModal}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>

                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                                انتخاب کنید
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleCloseFloorNumModal}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                        </Toolbar>
                    </AppBar>
                    <Box sx={{ mt: 3, px: 2, color: '#8F8F8F', display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '5px', paddingBottom: '70px' }}>

                        {Array.apply(0, Array(23)).map(function (x, i) {
                            return <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }} key={i}>
                                <input type="radio" id={`floorNum${i - 2}`} className="d-none floorCheck" value={i - 2} name="floorNum" onChange={(e) => handleChangeFloor(e, "FloorNo")} onClick={handleCloseFloorNumModal} />
                                <label htmlFor={`floorNum${i - 2}`} className='floorLabel inputs-container w-100 d-flex justify-content-around'>
                                    <div>طبقه</div>
                                    <div>{i - 2}</div>
                                </label>
                            </Box>
                        })
                        }

                    </Box>

                    <Button className='green-btn'
                        onClick={handleCloseFloorNumModal}
                        sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
                </Dialog>}

                {tmpSalePriceModal && <Dialog className="dialog-box"
                    fullScreen
                    open={tmpSalePriceModal}
                    onClose={handleSaleTmpSalePriceModalClose}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>

                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">

                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleSaleTmpSalePriceModalClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            {/* <Button autoFocus color="inherit" onClick={handleZoneModalClose}>
                                save
                            </Button> */}
                        </Toolbar>
                    </AppBar>
                    <Box>
                        <Grid container spacing={2} sx={{ px: 2 }}>
                            <Grid item xs={6}>
                                <TextField
                                    label=""
                                    placeholder='حداقل'
                                    name="sale-price"
                                    pattern="(\d)+"
                                    id="formatted-numberformat-input"
                                    className='remove-underline dir-ltr text-input-1 w-100'
                                    InputProps={{
                                        inputComponent: NumericFormatCustom,
                                    }}
                                    variant="standard"
                                    onChange={(e) => handleSetMinMaxSalePrice("MinSalePrice", e.target.value)}
                                    value={state.MinSalePrice}
                                    onFocus={() => setShowMeterItem(1)}
                                />

                                {
                                    showMeterItem == 1 ?
                                        <Box sx={{ mt: 2 }}>
                                            {
                                                priceItems.map((item, index) => {
                                                    return <Box className="price-item" key={index}>
                                                        <input type="radio" name="minPrice" id={`min-${index}`} className="d-none" onChange={() => {
                                                            handleSetMinMaxSalePrice("MinSalePrice", item.value)
                                                            setShowMeterItem(2)
                                                        }} />
                                                        <Button className='w-100 d-block' sx={{ textAlign: 'right' }}>
                                                            <label htmlFor={`min-${index}`} className='w-100 d-block'>
                                                                {item.title}
                                                            </label>
                                                        </Button>
                                                    </Box>
                                                })
                                            }
                                        </Box>
                                        : ''
                                }
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    label=""
                                    placeholder='حداکثر'
                                    name="sale-price"
                                    pattern="(\d)+"
                                    id="formatted-numberformat-input"
                                    className='remove-underline dir-ltr text-input-1 w-100'
                                    InputProps={{
                                        inputComponent: NumericFormatCustom,
                                    }}
                                    variant="standard"
                                    onFocus={() => setShowMeterItem(2)}
                                    value={state.MaxSalePrice}
                                    onChange={(e) => handleSetMinMaxSalePrice("MaxSalePrice", e.target.value)}
                                />
                                {
                                    showMeterItem == 2 ?
                                        <Box sx={{ mt: 2 }}>
                                            {
                                                priceItems.map((item, index) => {
                                                    return <Box className="price-item" key={index}>
                                                        <input type="radio" name="maxPrice" id={`max-${index}`} className="d-none" onChange={() => {
                                                            handleSetMinMaxSalePrice("MaxSalePrice", item.value)
                                                            //handleSaleTmpSalePriceModalClose()
                                                        }} />
                                                        <Button className='w-100 d-block' sx={{ textAlign: 'right' }}>
                                                            <label htmlFor={`max-${index}`} className='w-100 d-block'>
                                                                {item.title}
                                                            </label>
                                                        </Button>
                                                    </Box>
                                                })
                                            }
                                        </Box>
                                        : ''
                                }
                            </Grid>
                        </Grid>
                    </Box>
                    <Button
                        onClick={handleSaleTmpSalePriceModalClose}
                        className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
                </Dialog>}

                {tmpRentPriceModal && <Dialog className="dialog-box"
                    fullScreen
                    open={tmpRentPriceModal}
                    onClose={handleSaleTmpRentPriceModalClose}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>

                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">

                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleSaleTmpRentPriceModalClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            {/* <Button autoFocus color="inherit" onClick={handleZoneModalClose}>
                                save
                            </Button> */}
                        </Toolbar>
                    </AppBar>
                    <Box>
                        <Grid container spacing={2} sx={{ px: 2 }}>
                            <Grid item xs={6}>
                                <TextField
                                    label=""
                                    placeholder='حداقل'
                                    name="sale-price"
                                    pattern="(\d)+"
                                    id="formatted-numberformat-input"
                                    className='remove-underline dir-ltr text-input-1 w-100'
                                    InputProps={{
                                        inputComponent: NumericFormatCustom,
                                    }}
                                    variant="standard"
                                    onChange={(e) => handleSetMinMaxSalePrice("MinRentPrice", e.target.value)}
                                    value={state.MinRentPrice}
                                    onFocus={() => setShowMeterItem(1)}
                                />
                                {
                                    showMeterItem == 1 ?
                                        <Box sx={{ mt: 2 }}>
                                            {
                                                priceItems.map((item, index) => {
                                                    return <Box className="price-item" key={index}>
                                                        <input type="radio" name="minPrice" id={`min-${index}`} className="d-none" onChange={() => {
                                                            handleSetMinMaxSalePrice("MinRentPrice", item.value)
                                                            setShowMeterItem(2)
                                                        }} />
                                                        <Button className='w-100 d-block' sx={{ textAlign: 'right' }}>
                                                            <label htmlFor={`min-${index}`} className='w-100 d-block'>
                                                                {item.title}
                                                            </label>
                                                        </Button>
                                                    </Box>
                                                })
                                            }
                                        </Box>
                                        : ''
                                }
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    label=""
                                    placeholder='حداکثر'
                                    name="sale-price"
                                    pattern="(\d)+"
                                    id="formatted-numberformat-input"
                                    className='remove-underline dir-ltr text-input-1 w-100'
                                    InputProps={{
                                        inputComponent: NumericFormatCustom,
                                    }}
                                    variant="standard"
                                    onFocus={() => setShowMeterItem(2)}
                                    value={state.MaxRentPrice}
                                    onChange={(e) => handleSetMinMaxSalePrice("MaxRentPrice", e.target.value)}
                                />
                                {
                                    showMeterItem == 2 ?
                                        <Box sx={{ mt: 2 }}>
                                            {
                                                priceItems.map((item, index) => {
                                                    return <Box className="price-item" key={index}>
                                                        <input type="radio" name="maxPrice" id={`max-${index}`} className="d-none" onChange={() => {
                                                            handleSetMinMaxSalePrice("MaxRentPrice", item.value)
                                                            //handleSaleTmpRentPriceModalClose()
                                                        }} />
                                                        <Button className='w-100 d-block' sx={{ textAlign: 'right' }}>
                                                            <label htmlFor={`max-${index}`} className='w-100 d-block'>
                                                                {item.title}
                                                            </label>
                                                        </Button>
                                                    </Box>
                                                })
                                            }
                                        </Box>
                                        : ''
                                }
                            </Grid>
                        </Grid>
                    </Box>
                    <Button
                        onClick={handleSaleTmpRentPriceModalClose}
                        className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
                </Dialog>}

                {tmpMortgagePriceModal && <Dialog className="dialog-box"
                    fullScreen
                    open={tmpMortgagePriceModal}
                    onClose={handleSaleTmpMortgagePriceModalClose}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>

                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">

                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleSaleTmpMortgagePriceModalClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            {/* <Button autoFocus color="inherit" onClick={handleZoneModalClose}>
                                save
                            </Button> */}
                        </Toolbar>
                    </AppBar>
                    <Box>
                        <Grid container spacing={2} sx={{ px: 2 }}>
                            <Grid item xs={6}>
                                <TextField
                                    label=""
                                    placeholder='حداقل'
                                    name="sale-price"
                                    pattern="(\d)+"
                                    id="formatted-numberformat-input"
                                    className='remove-underline dir-ltr text-input-1 w-100'
                                    InputProps={{
                                        inputComponent: NumericFormatCustom,
                                    }}
                                    variant="standard"
                                    onChange={(e) => handleSetMinMaxSalePrice("MinMortgagePrice", e.target.value)}
                                    value={state.MinMortgagePrice}
                                    onFocus={() => setShowMeterItem(1)}
                                />
                                {
                                    showMeterItem == 1 ?
                                        <Box sx={{ mt: 2 }}>
                                            {
                                                priceItems.map((item, index) => {
                                                    return <Box className="price-item" key={index}>
                                                        <input type="radio" name="minPrice" id={`min-${index}`} className="d-none" onChange={() => {
                                                            handleSetMinMaxSalePrice("MinMortgagePrice", item.value)
                                                            setShowMeterItem(2)
                                                        }} />
                                                        <Button className='w-100 d-block' sx={{ textAlign: 'right' }}>
                                                            <label htmlFor={`min-${index}`} className='w-100 d-block'>
                                                                {item.title}
                                                            </label>
                                                        </Button>
                                                    </Box>
                                                })
                                            }
                                        </Box>
                                        : ''
                                }
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    label=""
                                    placeholder='حداکثر'
                                    name="sale-price"
                                    pattern="(\d)+"
                                    id="formatted-numberformat-input"
                                    className='remove-underline dir-ltr text-input-1 w-100'
                                    InputProps={{
                                        inputComponent: NumericFormatCustom,
                                    }}
                                    variant="standard"
                                    onFocus={() => setShowMeterItem(2)}
                                    value={state.MaxMortgagePrice}
                                    onChange={(e) => handleSetMinMaxSalePrice("MaxMortgagePrice", e.target.value)}
                                />
                                {
                                    showMeterItem == 2 ?
                                        <Box sx={{ mt: 2 }}>
                                            {
                                                priceItems.map((item, index) => {
                                                    return <Box className="price-item" key={index}>
                                                        <input type="radio" name="maxPrice" id={`max-${index}`} className="d-none" onChange={() => {
                                                            handleSetMinMaxSalePrice("MaxMortgagePrice", item.value)
                                                            //handleSaleTmpMortgagePriceModalClose()
                                                        }} />
                                                        <Button className='w-100 d-block' sx={{ textAlign: 'right' }}>
                                                            <label htmlFor={`max-${index}`} className='w-100 d-block'>
                                                                {item.title}
                                                            </label>
                                                        </Button>
                                                    </Box>
                                                })
                                            }
                                        </Box>
                                        : ''
                                }
                            </Grid>
                        </Grid>
                    </Box>
                    <Button
                        onClick={handleSaleTmpMortgagePriceModalClose}
                        className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
                </Dialog>}

                {/*openZoneModal && <Dialog className="dialog-box"
                    fullScreen
                    open={openZoneModal}
                    onClose={handleClose}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>

                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                                انتخاب محدوده
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                          
                        </Toolbar>
                    </AppBar>
                    <Box sx={{ px: 2, mt: 3, color: '#8F8F8F' }}>
                        <Box className="inputs-container" sx={{ display: "flex", width: 'auto', alignItems: "center", border: '0px', bgcolor: '#EEEBEB' }}>
                            <InputBase placeholder='محدوده یا محله مورد نظر خود را وارد کنید' className='flex-1' onChange={areasSearchHandle} />
                            <IconButton>
                                <SreachIcon />
                            </IconButton>
                        </Box>
                        <Box sx={{ px: 1, mt: 3, color: '#8F8F8F', display: 'flex', flexDirection: 'column', gap: '15px', paddingBottom: '70px' }}>
                            <Grid container spacing={3}>
                                {areasItems.length ? areasItems.map((areasItem, index) => (
                                    <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                        <input type="radio" name='propertyType' checked={areasItem.Name == state.PropertyArea} value={areasItem.Name} data_locationid={areasItem.LocationId} id={`PropertyArea${index}`} className="d-none floorCheck" onChange={PropertyAreaHandle} />
                                        <label htmlFor={`PropertyArea${index}`} className='inputs-container floorLabel w-100'>
                                            <span className="flex-1">{areasItem.Name}</span>
                                        </label>
                                    </Grid>
                                )) : <Box sx={{ textAlign: 'center', mt: 2, width: '100%' }}>موردی یافت نشد!</Box>}
                            </Grid>
                        </Box>
                    </Box>
                    <Button
                        onClick={handleClose}
                        className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
                                </Dialog>*/}

                {rentPredereModal && <Dialog className="dialog-box"
                    fullScreen
                    open={rentPredereModal}
                    onClose={handleSaleRentPreferModalClose}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>

                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                                ارجحیت اجاره
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleSaleRentPreferModalClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                        </Toolbar>
                    </AppBar>
                    <Box sx={{ px: 2, color: '#8F8F8F', display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px', paddingBottom: '70px' }}>
                        <Box sx={{ px: 1, mt: 3, color: '#8F8F8F', display: 'flex', flexDirection: 'column', gap: '15px' }}>
                            <Grid container spacing={3} sx={{ pt: 2 }} className='gap-top-20'>
                                {rentPrefer.map((key, index) => (
                                    <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                        <input type="checkbox" id={`rentPrefer${index}`} className="d-none typeCheck" value={key} onChange={RentPreferHandle} checked={state.RentPrefer.includes(key)} />
                                        <label htmlFor={`rentPrefer${index}`} className='typeLabel'>
                                            {key}
                                        </label>
                                    </Grid>
                                ))}

                            </Grid>

                        </Box>
                    </Box>
                    <Button className='green-btn'
                        onClick={handleSaleRentPreferModalClose}
                        sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
                </Dialog>}

                {openTypeZone && <Dialog className="dialog-box"
                    fullScreen
                    open={openTypeZone}
                    onClose={handleOpenTypeZoneClose}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>
                            {/* <IconButton>
                <SettingIcon />
            </IconButton> */}
                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                                {/* انتخاب محدوده */}
                            </Typography>

                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleOpenTypeZoneClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            {/* <Button autoFocus color="inherit" onClick={handleClose}>
                    save
                </Button> */}
                        </Toolbar>
                    </AppBar>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px', mt: 2, paddingBottom: '80px', px: 2 }}>
                        <Box>
                            <input type="radio" name='propType' id="myOptions" className="d-none typeCheck" checked={typeZone == "1"} value="موارد خودم" onChange={() => setTypeZone("1")} />
                            <label htmlFor="myOptions" className='typeLabel w-auto justify-content-right gap-10'>
                                <PersonList />
                                موارد خودم
                            </label>
                        </Box>
                        <Box>
                            <input type="radio" name='propType' id="daryafti" className="d-none typeCheck" checked={typeZone == "2"} value="موارد دریافتی از پایش" onChange={() => setTypeZone("2")} />
                            <label htmlFor="daryafti" className='typeLabel w-auto justify-content-right gap-10'>
                                <DownloadIcon />
                                موارد دریافتی از پایش
                            </label>
                        </Box>
                    </Box>
                    <Button className='green-btn' onClick={handleOpenTypeZoneClose} sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>جستجو</Button>
                </Dialog>}

                {selectMeterModal && <Dialog className="dialog-box"
                    fullScreen
                    open={selectMeterModal}
                    onClose={handleSelectMeterModalClose}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>

                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">

                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleSelectMeterModalClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            {/* <Button autoFocus color="inherit" onClick={handleZoneModalClose}>
                                save
                            </Button> */}
                        </Toolbar>
                    </AppBar>
                    <Box>
                        <Grid container spacing={2} sx={{ px: 2 }}>
                            <Grid item xs={6}>
                                <TextField
                                    label=""
                                    placeholder='حداقل'
                                    name="sale-price"
                                    pattern="(\d)+"
                                    id="formatted-numberformat-input"
                                    className='remove-underline dir-ltr text-input-1 w-100'
                                    InputProps={{
                                        inputComponent: NumericFormatCustom,
                                    }}
                                    variant="standard"
                                    onFocus={() => setShowPriceItem(1)}
                                    value={state.MinInfrastructure}
                                    onChange={(e) => handleSetMinMaxMeter("MinInfrastructure", e.target.value)}
                                />
                                {
                                    showPriceItem == 1 ?
                                        <Box sx={{ mt: 2 }}>
                                            {
                                                meterItems.map((item, index) => {
                                                    return <Box className="price-item" key={index}>
                                                        <input type="radio" name="minMeter" id={`min-${index}`} className="d-none" onChange={() => {
                                                            handleSetMinMaxMeter("MinInfrastructure", item)
                                                            setShowPriceItem(2)
                                                        }} />
                                                        <Button className='w-100 d-block' sx={{ textAlign: 'right' }}>
                                                            <label htmlFor={`min-${index}`} className='w-100 d-block'>
                                                                {item} متر
                                                            </label>
                                                        </Button>
                                                    </Box>
                                                })
                                            }
                                        </Box>
                                        : ''
                                }
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    label=""
                                    placeholder='حداکثر'
                                    name="sale-price"
                                    pattern="(\d)+"
                                    id="formatted-numberformat-input"
                                    className='remove-underline dir-ltr text-input-1 w-100'
                                    InputProps={{
                                        inputComponent: NumericFormatCustom,
                                    }}
                                    variant="standard"
                                    onFocus={() => setShowPriceItem(2)}
                                    value={state.MaxInfrastructure}
                                    onChange={(e) => handleSetMinMaxMeter("MaxInfrastructure", e.target.value)}
                                />
                                {
                                    showPriceItem == 2 ?
                                        <Box sx={{ mt: 2 }}>
                                            {
                                                meterItems.map((item, index) => {
                                                    return <Box className="price-item" key={index}>
                                                        <input type="radio" name="maxMeter" id={`max-${index}`} className="d-none" onChange={() => {
                                                            handleSetMinMaxMeter("MaxInfrastructure", item)
                                                            //handleSelectMeterModalClose()
                                                        }} />
                                                        <Button className='w-100 d-block' sx={{ textAlign: 'right' }}>
                                                            <label htmlFor={`max-${index}`} className='w-100 d-block'>
                                                                {item} متر
                                                            </label>
                                                        </Button>
                                                    </Box>
                                                })
                                            }
                                        </Box>
                                        : ''
                                }
                            </Grid>
                        </Grid>
                    </Box>
                    <Button
                        onClick={handleSelectMeterModalClose}
                        className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
                </Dialog>}

                {selectSpaceModal && <Dialog className="dialog-box"
                    fullScreen
                    open={selectSpaceModal}
                    onClose={handleSelectSpaceModalClose}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>

                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">

                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleSelectSpaceModalClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            {/* <Button autoFocus color="inherit" onClick={handleZoneModalClose}>
                                save
                            </Button> */}
                        </Toolbar>
                    </AppBar>
                    <Box>
                        <Grid container spacing={2} sx={{ px: 2 }}>
                            <Grid item xs={6}>
                                <TextField
                                    label=""
                                    placeholder='حداقل'
                                    name="sale-price"
                                    pattern="(\d)+"
                                    id="formatted-numberformat-input"
                                    className='remove-underline dir-ltr text-input-1 w-100'
                                    InputProps={{
                                        inputComponent: NumericFormatCustom,
                                    }}
                                    variant="standard"
                                    onFocus={() => setShowPriceItem(1)}
                                    value={state.MinSpace}
                                    onChange={(e) => handleSetMinMaxMeter("MinSpace", e.target.value)}
                                />
                                {
                                    showPriceItem == 1 ?
                                        <Box sx={{ mt: 2 }}>
                                            {
                                                meterItems.map((item, index) => {
                                                    return <Box className="price-item" key={index}>
                                                        <input type="radio" name="minMeter" id={`min-${index}`} className="d-none" onChange={() => {
                                                            handleSetMinMaxMeter("MinSpace", item)
                                                            setShowPriceItem(2)
                                                        }} />
                                                        <Button className='w-100 d-block' sx={{ textAlign: 'right' }}>
                                                            <label htmlFor={`min-${index}`} className='w-100 d-block'>
                                                                {item} متر
                                                            </label>
                                                        </Button>
                                                    </Box>
                                                })
                                            }
                                        </Box>
                                        : ''
                                }
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    label=""
                                    placeholder='حداکثر'
                                    name="sale-price"
                                    pattern="(\d)+"
                                    id="formatted-numberformat-input"
                                    className='remove-underline dir-ltr text-input-1 w-100'
                                    InputProps={{
                                        inputComponent: NumericFormatCustom,
                                    }}
                                    variant="standard"
                                    onFocus={() => setShowPriceItem(2)}
                                    value={state.MaxSpace}
                                    onChange={(e) => handleSetMinMaxMeter("MaxSpace", e.target.value)}
                                />
                                {
                                    showPriceItem == 2 ?
                                        <Box sx={{ mt: 2 }}>
                                            {
                                                meterItems.map((item, index) => {
                                                    return <Box className="price-item" key={index}>
                                                        <input type="radio" name="maxMeter" id={`max-${index}`} className="d-none" onChange={() => {
                                                            handleSetMinMaxMeter("MaxSpace", item)
                                                            //handleSelectSpaceModalClose()
                                                        }} />
                                                        <Button className='w-100 d-block' sx={{ textAlign: 'right' }} >
                                                            <label htmlFor={`max-${index}`} className='w-100 d-block'>
                                                                {item} متر
                                                            </label>
                                                        </Button>
                                                    </Box>
                                                })
                                            }
                                        </Box>
                                        : ''
                                }
                            </Grid>
                        </Grid>
                    </Box>
                    <Button
                        onClick={handleSelectSpaceModalClose}
                        className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
                </Dialog>}

                {yearCreated && <Dialog className="dialog-box"
                    fullScreen
                    open={yearCreated}
                    onClose={handleCloseYearCreatedModal}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: '#fff', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>

                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                                انتخاب کنید
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleCloseYearCreatedModal}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                        </Toolbar>
                    </AppBar>
                    <Box sx={{ mt: 3, px: 2, color: '#8F8F8F', display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '5px', paddingBottom: '70px' }}>
                        {yearDates.map(function (date, i) {
                            return <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }} key={i}>
                                <input type="checkbox" id={`year${date}`} className="d-none floorCheck" checked={state.PropertyAge.includes(nowDate - date)} value={date} name="year" onChange={PropertyAgeYearHandle} />
                                <label htmlFor={`year${date}`} className='floorLabel inputs-container w-100 d-flex justify-content-around'>
                                    <div>{nowDate - date != 0 ? `${date} (${nowDate - date} سال ساخت)` : date} </div>
                                </label>
                            </Box>
                        })}
                    </Box>

                    <Button className='green-btn'
                        onClick={handleCloseYearCreatedModal}
                        sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
                </Dialog>}
            </Box >
        </PageLayout>

    );
}

export default EditDemand;